import { subscriptionFAQListModel } from './../../../tech-vendor/shared/models/subscriptioFAQListModel';
import { Component, OnInit, Inject, OnDestroy, ChangeDetectorRef, ViewChildren, QueryList, ViewChild } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { AuthenticationService } from "@app/shared/services/authentication.service";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { RolesSharedService } from "@app/feature/main/roles-shared/services/roles-shared.service";
import { ResponseContentType, Http } from "@angular/http";
import {
  ResearchData,
  CategoryData
} from "@app/feature/main/roles-shared/models/researchDataModel";
import * as _ from 'lodash';
import swal from "sweetalert2";
import { MarketDataChartGeneratorService } from "@app/feature/main/roles-shared/services/market-data-chart-generator.service";
import { MarketDataDetailsService } from "@app/feature/main/roles-shared/services/market-data-details.service";
import { NickNameModalService } from "@app/feature/main/roles-shared/services/nick-name-modal.service";
import { CommentModalService } from "@app/shared/services/comment-modal.service";
import { MixpanelEventLoggingService } from "@shared/services/mixpanel-event-logging.service";
import { IAppState, rootReducer, INITIAL_STATE } from "@app/stateManagement/state";
import { NgRedux, select } from "@angular-redux/store";
import { Observable } from "rxjs";
import { MarketData, AdminFilteredData, MarketDataChartJSON } from '@app/feature/main/roles-shared/models/marketDataModel';
import { UtilityService } from "@app/shared/services/utility.service";
import { ChartComponent } from '@app/feature/main/roles-shared/components/chart/chart.component';
import { LinkShareComponent } from '@app/shared/components/link-share/link-share.component';
import { SocialShare } from '@app/shared/services/social-share.service';
import { SSTService } from '@app/feature/main/roles-shared/services/self-service-tab.service';
import { LikeModalServiceService } from "@app/shared/services/like-modal-service.service";
import { findIndex } from 'rxjs/operators';
import { Toastr } from '@app/shared/constants/app.constants';
import { LoaderService } from "@app/shared/services/loader.service";
import { Meta, Title } from '@angular/platform-browser';
declare var $: any;
declare var window: any;
@Component({
  selector: "app-research-detail",
  templateUrl: "./research-detail.component.html",
  styleUrls: ["./research-detail.component.css"],
  providers: [UtilityService]
})
export class ResearchDetailComponent implements OnInit, OnDestroy {
  @select() categoryStatus;
  categoryStatusData: any;
  marketDataContent: any = new MarketData();
  private userFilteredData = new MarketData(); // final filter model
  private userFilteredData1 = {
    industryId: [],
    itBudgetId: [],
    geographyId: [],
    lineOfBusinessId: [],
    countryId: [],
    employeeSizeId: [],
    jobTitleId: [],
    globalRevenueId: [],
    subTechDomainId: []
  };
  userFiltersAdded: any = {};
  paramObj;
  researchData: any;
  loggedInStatus = false;
  userRole;
  userDetailsObject;
  userId;
  dataLimit = 2;
  skipValue = 0;

  marketDataCategory: any;
  marketDataSubCategory: Array<any>;

  researchDataId: string;
  categoryId: string;
  subCategegoryId: string;

  marketChartData = null;
  marketData: any = [];
  rating = 0;
  marketDataFilter: any = {};
  marketDataSubCatId: string;

  private previousUrl: string;
  private currentUrl: string;
  marketDataSubscription: any;
  highChartSubscrition: any;
  marketDataFullDetails: any = [];
  scrollSet: boolean;
  userFilterList: any;
  noFilterDataFlag = false;
  userFilterListClone: any = {};
  userBenchmark: any = {};
  filteredID = {
    industryId: [],
    itBudgetId: [],
    geographyId: [],
    lineOfBusinessId: [],
    countryId: [],
    employeeSizeId: [],
    jobTitleId: [],
    globalRevenueId: [],
    subTechDomainId: []
  };
  filteredName = {
    industryName: [],
    itBudgetName: [],
    geographyName: [],
    lineOfBusinessName: [],
    countryName: [],
    employeeSizeName: [],
    jobTitleName: [],
    globalRevenueName: [],
    subDomainName: []
  };
  employeeSizelabel: string;
  itBudgetSelectionLabel: any;
  revenueLabel: string;
  activeMainCategoryId: string;
  activeSubMarketId: string;
  previousSelectedQuestionFilter = [];
  previousSelectedClusterQuestionFilter = [];
  @ViewChildren(ChartComponent) chartChildren: QueryList<ChartComponent>;
  @ViewChild(LinkShareComponent) linkShare: LinkShareComponent;
  chartChildrenArray: ChartComponent[];
  benchMarkModalStatus = false;
  benchMarkFilter: any = {
    againstAll: false,
    againstMyDomain: false,
    myDomainVsAllDomain: false
  };
  currentBenchmarkFilterIndex: number;
  currentTimeLineFilterIndex: number;
  showReportsLinks = [];
  timeLineAnalysisModalStatus = false;
  timeLineAnalysisFilter: any = {

  };
  timeAnalysisStartDate: Date;
  timeAnalysisEndDate: Date;
  geographyResponse: any = [];
  selectedCountryResponse: any = [];
  countryIdArray: any = [];
  profileFilterArray: any[];
  techDomainId: string;
  solutionFilter: any = {};
  searchString: string;
  solution: any;
  vendorRole: string;
  roleStatus: boolean;
  geographyCountryMaping: any;
  isParent: boolean;
  solutionCheckDataflag: boolean;
  customQuestionCheckFlag: boolean;
  adoptionCount: number = 0;
  maturityCount: number = 0;
  selectedCustomQuestionChoices: any = [];
  vendorFiltersNamesMapping = [];
  questionNamesmapping = [];
  selectedDistinctCustomQuestions = [];
  isFilterApplied: boolean = false;
  hasMasterFilter: boolean = false;
  userProfileClusterFilter = [];
  userProfileFilter = [
    {
      index: 0,
      title: 'Industry',
      type: 'industry',
      data: [],
      dataIds: [],
      checked: false,
      showItems: false
    },
    {
      index: 1,
      title: 'IT Budget',
      type: 'it_budget',
      data: [],
      dataIds: [],
      checked: false,
      showItems: false
    },
    {
      index: 2,
      title: 'Region',
      type: 'geography',
      data: [],
      dataIds: [],
      checked: false,
      showItems: false
    },
    {
      index: 3,
      title: 'Line of Business',
      type: 'line_of_business',
      data: [],
      dataIds: [],
      checked: false,
      showItems: false
    },
    {       
      index: 4,
      title: 'Country',
      type: 'country',
      data: [],
      dataIds: [],
      checked: false,
      showItems: false
    },
    { 
      index: 5,
      title: 'Employee Size',
      type: 'employee_size',
      data: [],
      dataIds: [],
      checked: false,
      showItems: false
    },
    {
      index: 6,
      title: 'Job Title',
      type: 'job_title',
      data: [],
      dataIds: [],
      checked: false,
      showItems: false
    },
    {
      index: 7,
      title: 'Global Revenue',
      type: 'global_revenue',
      data: [],
      dataIds: [],
      checked: false,
      showItems: false
    }
  ];
  segmentFilteredData = [
    {
      index: 0,
      title: 'Industry',
      type: 'industry',
      data: [],
      checked: false,
      dataName: [],
      dataIds: [],
      finalKey: 'industryId'
    },
    {
      index: 1,
      title: 'IT Budget',
      type: 'it_budget',
      data: [],
      checked: false,
      dataName: [],
      dataIds: [],
      finalKey: 'itBudgetId'

    },
    {
      index: 2,
      title: 'Region',
      type: 'geography',
      data: [],
      checked: false,
      dataName: [],
      dataIds: [],
      finalKey: 'geographyId'
    },
    {
      index: 3,
      title: 'Line of Business',
      type: 'line_of_business',
      data: [],
      checked: false,
      dataName: [],
      dataIds: [],
      finalKey: 'lineOfBusinessId'

    },
    {
      index: 4,
      title: 'Country',
      type: 'country',
      data: [],
      checked: false,
      dataName: [],
      dataIds: [],
      finalKey: 'countryId'


    },
    {
      index: 5,
      title: 'Employee Size',
      type: 'employee_size',
      data: [],
      checked: false,
      dataName: [],
      dataIds: [],
      finalKey: 'employeeSizeId'


    },
    {
      index: 6,
      title: 'Job Title',
      type: 'job_title',
      data: [],
      checked: false,
      dataName: [],
      dataIds: [],
      finalKey: 'jobTitleId'


    },
    {
      index: 7,
      title: 'Global Revenue',
      type: 'global_revenue',
      data: [],
      checked: false,
      dataName: [],
      dataIds: [],
      finalKey: 'globalRevenueId'


    }
  ];
  selectedIndex: number;
  isSegmentChecked: boolean = false;
  isSegmentFilterDisabled: boolean = false;
  selectedData: any;
  selectedSegment: any;
  hasAppliedFilters: boolean = false;
  appliedFilterList: any;
  finalAppliedMasterFilter: any;
  resetActive:boolean = false;
  disableOptions: boolean = true;
  noSearchResults: boolean = false;
  lowerParameter: number;
  upperParameter: number;
  veryLowSampleSize: boolean = false;
  isApplyTrue: boolean = false;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private utilityService: UtilityService,
    private rolesSharedService: RolesSharedService,
    private marketDataChartGenerator: MarketDataChartGeneratorService,
    private marketDataDetailsService: MarketDataDetailsService,
    private nickNameModalService: NickNameModalService,
    private commentModalService: CommentModalService,
    private mixpanelEventLoggingService: MixpanelEventLoggingService,
    private ref: ChangeDetectorRef,
    private ngRedux: NgRedux<IAppState>,
    private socialShareService: SocialShare,
    private likeModalService: LikeModalServiceService,
    private sstService: SSTService,
    private http: Http,
    private cdRef:ChangeDetectorRef,
    private loaderService: LoaderService,
    private titleService: Title,
  ) {
    this.document.body.classList.add("inner-page");
    this.document.body.classList.remove("outer-page");
    // window.scroll(0, 0);

    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        if ((this.previousUrl.includes('/market-data-details') || this.previousUrl.includes('/market-data-detail') || this.previousUrl.includes('/research-detail/'))
          && (this.currentUrl.includes('/market-data-details') || this.currentUrl.includes('/market-data-detail') || this.currentUrl.includes('/research-detail/'))) {

        } else {
          this.ngRedux.dispatch({ type: 'UPDATE_CATEGORY', category: undefined });
        }
      }

    });
  }

  ngOnInit() {
    this.getUserRole();
    this.researchDataId = this.route.snapshot.paramMap.get("id");
    sessionStorage.removeItem('isPrimeCall');
    this.isLoggedIn();
    this.getMarketDataCategories();
    this.userDetails();
    this.getResearchData(this.researchDataId);
    this.rolesSharedService.getGeographyOfSelectedCountries().subscribe((response) => {
      this.geographyCountryMaping = response;
    })
    // this.getSolutionFilterList(this.solutionFilter);
  }

  sstMarketData: any;
  sstGraphMarketData: any;

  shareChart(index, type, researchData) {
    this.chartChildrenArray = this.chartChildren.toArray();
    this.chartChildrenArray[index].getChartBase64().then(base64 => {
      const data = {
        postType: 'research_document',
        postId: researchData.id ? researchData.id : '',
        image: base64
      };
      this.socialShareService.saveSocialShare(data).subscribe(response => {
        this.linkShare.showModal(type, researchData, response['id']);
      });
    }).catch(err => { });
  }
  resetFilter(i) {
    _.forEach(this.marketData[i].marketData.customQuestionFilters, (obj) => {
      obj.searchString = undefined;
      obj.noSearchResults = false;
    });
    _.forEach(this.marketData[i].marketData.customUserProfileFilters, (obj) => {
      obj.searchString = undefined;
      obj.noSearchResults = false;
    });
    for (let key in this.marketData[i].marketData.userFilters) {
      if (this.marketData[i].marketData.userFilters[key]) { // resolved search string of undefined issue
        this.marketData[i].marketData.userFilters[key].searchString = undefined;
        this.marketData[i].marketData.userFilters[key].noSearchResults = false;
        this.marketData[i].marketData.userFilters[key].forEach((obj) => {
          obj.status = false;
        });
      }
    }
    if (this.marketData[i].marketData.customQuestionFiltersBackup) {
      this.marketData[i].marketData.customQuestionFiltersBackup.forEach((questionFilter: any) => {
        questionFilter.status = false;
        questionFilter.searchString = undefined;
        questionFilter.noSearchResults = false;
        questionFilter.choiceId.forEach((choice: any) => {
          choice.status = false;
        });
        questionFilter.customChoiceFilter.forEach((choice: any) => {
          choice.status = false;
        });
      });
      this.marketData[i].marketData.customQuestionFilters =
      _.cloneDeep(this.marketData[i].marketData.customQuestionFiltersBackup);
    }
    if (this.marketData[i].marketData.customUserProfileFiltersBackup) {
      this.marketData[i].marketData.customUserProfileFiltersBackup.forEach((profileFilter: any) => {
        profileFilter.status = false;
        profileFilter.searchString = undefined;
        profileFilter.noSearchResults = false;
        profileFilter.profileData.forEach((obj) => {
          obj.status = false;
        })
      });
      this.marketData[i].marketData.customUserProfileFilters =
      _.cloneDeep(this.marketData[i].marketData.customUserProfileFiltersBackup);
    }
    if (this.marketData[i].marketData.userFiltersBackup) {
      for (let key in this.marketData[i].marketData.userFiltersBackup) {
        this.marketData[i].marketData.userFiltersBackup[key].searchString = undefined;
        this.marketData[i].marketData.userFiltersBackup[key].noSearchResults = false;
        this.marketData[i].marketData.userFiltersBackup[key].forEach((obj) => {
          obj.status = false;
        });
      }
      
      this.marketData[i].marketData.userFilters =
      _.cloneDeep(this.marketData[i].marketData.userFiltersBackup);
    }
    this.marketData[i].noSearchResults = false;
    this.marketData[i].isFilterApplied = false;
    this.previousSelectedClusterQuestionFilter[i] = [];
    this.previousSelectedQuestionFilter[i] = [];
    this.marketData[i].marketData.apply = false;
    this.resetBenchMarkFilters(i);
    if (this.marketData[i].marketData.timeline && this.currentTimeLineFilterIndex) {
      this.resetTimeLineAnalysisChanges();
    }
    if (this.marketData[i].marketData.customQuestionFilters) {
      this.marketData[i].marketData.customQuestionFilters.forEach((questionFilter: any) => {
        if (questionFilter) {
          questionFilter.status = false;
          questionFilter.choiceId.forEach((choice: any) => {
            if (choice) {
              choice.status = false;
            }
          });
          questionFilter.customChoiceFilter.forEach((choice: any) => {
            if (choice) {
              choice.status = false;
            }
          });
          questionFilter.checkedQuestionFilter = false;
        }
      });
    }
    if (this.marketData[i].marketData.customUserProfileFilters) {
      this.marketData[i].marketData.customUserProfileFilters.forEach((profileFilter: any) => {
        if (profileFilter) {
          profileFilter.status = false;
          profileFilter.profileData.forEach((choice: any) => {
            if (choice) {
              choice.status = false;
            }
          });
        }
      });
    }
    if (this.marketData[i].marketData.userFilters.country) {
      delete this.marketData[i].marketData.userFilteredDataCountryNameValue;
      this.marketData[i].marketData.userFilters.country.forEach((element: any) => {
        if (element) {
          element.status = false;
        }
      });
    }
    if (this.marketData[i].marketData.userFilters.solutions) {
      delete this.marketData[i].marketData.userFilteredDataSubDomainNameValue;
      this.marketData[i].marketData.userFilters.solutions.forEach((element: any) => {
        if (element) {
          element.status = false;
        }
      });
    }
    if (this.marketData[i].marketData.userFilters.employeeSize) {
      delete this.marketData[i].marketData.userFilteredDataEmployeeValue;
      this.marketData[i].marketData.userFilters.employeeSize.forEach((element: any) => {
        if (element) {
          element.status = false;
        }
      });
    }
    if (this.marketData[i].marketData.userFilters.geography) {
      delete this.marketData[i].marketData.userFilteredDatageographyNameValue;
      this.marketData[i].marketData.userFilters.geography.forEach((element: any) => {
        if (element) {
          element.status = false;
        }
      });
    }
    if (this.marketData[i].marketData.userFilters.industry) {
      delete this.marketData[i].marketData.userFilteredDataindustryNameValue;
      this.marketData[i].marketData.userFilters.industry.forEach((element: any) => {
        if (element) {
          element.status = false;
        }
      });
    }
    if (this.marketData[i].marketData.userFilters.itBudget) {
      delete this.marketData[i].marketData.userFilteredDataitBudgetNameValue;
      this.marketData[i].marketData.userFilters.itBudget.forEach((element: any) => {
        if (element) {
          element.status = false;
        }
      });
    }
    if (this.marketData[i].marketData.userFilters.jobTitle) {
      delete this.marketData[i].marketData.userFilteredDatajobTitleNameValue;
      this.marketData[i].marketData.userFilters.jobTitle.forEach((element: any) => {
        if (element) {
          element.status = false;
        }
      });
    }
    if (this.marketData[i].marketData.userFilters.lineOfBusiness) {
      delete this.marketData[i].marketData.userFilteredDatalineOfBusinessNameValue;
      this.marketData[i].marketData.userFilters.lineOfBusiness.forEach((element: any) => {
        if (element) {
          element.status = false;
        }
      });
    }
    if (this.marketData[i].marketData.userFilters.revenue) {
      delete this.marketData[i].marketData.userFilteredDatarevenueNameValue;
      this.marketData[i].marketData.userFilters.revenue.forEach((element: any) => {
        if (element) {
          element.status = false;
        }
      });
    }
    if (this.marketData[i].marketData.customQuestionFilters) {
      delete this.marketData[i].marketData.customFilteredChoiceNameValue;
      delete this.marketData[i].marketData.customFilteredChoiceNameValueAdoption;
      delete this.marketData[i].marketData.customFilteredLabelsAdoption;
      delete this.marketData[i].marketData.customFilteredLabels;
      // this.marketData[j].marketData.customQuestionFilters[qIndex].customChoiceFilter
      this.marketData[i].marketData.customQuestionFilters.forEach((element: any) => {
        if (element) {
          element.status = false;
        }
        if (element.customChoiceFilter) {
          element.customChoiceFilter.forEach((innerElement: any) => {
            innerElement.status = false;
          });
        }
        if (element.choiceId) {
          element.choiceId.forEach((innerElement: any) => {
            innerElement.status = false;
          });
        }
      });
    }
    for (const key in this.userFilteredData) {
      this.marketDataContent[key] = [...[]];
    }
    for (const key in this.userFilteredData) {
      this.userFilteredData[key] = [...[]];
    }
    // this.solutionCheckDataflag = false;
    this.marketData[i].marketData.solutionCheckDataflag = false;
    // this.customQuestionCheckFlag = false;
    this.marketData[i].marketData.customQuestionCheckFlag = false;
    this.marketData[i].marketData.disableFlag = false;
    this.selectedDistinctCustomQuestions = [];
    if (this.marketDataContent.graphTypeId === null || this.marketDataContent.graphTypeId === undefined) {
      this.marketDataContent[`graphTypeId`] = this.marketData[i].marketData.graphTypeId;
    }
    this.marketDataContent[`marketDataId`] = this.marketData[i].marketData.id;
    this.marketDataContent[`isClustered`] = this.marketData[i].marketData.isClustered || false;
    this.marketDataContent[`customQuestionFilters`] = [];
    this.marketDataContent[`subTechDomainId`] = [];
    this.marketDataContent[`isParentQuestionGraph`] = this.marketData[i].marketData.isParentQuestionGraph || false;
    this.marketDataContent[`hasSolutionFilter`] = this.marketData[i].marketData.hasSolutionFilter || false;
    this.rolesSharedService.filterMarketData(this.marketDataContent, this.marketData[i].researchDocumentId).subscribe((filteredData: any) => {
      //  this.marketData=[];
      this.marketData[i].marketData.marketData = filteredData.data;
      this.marketData[i].marketData.numberOfResponse = filteredData.numberOfResponse;
      if (this.marketData[i].marketData.numberOfResponse < this.lowerParameter) {
        this.marketData[i].marketData['setMessage'] = true;
      }
      if (this.marketData[i].marketData.numberOfResponse >= this.lowerParameter) {
        this.marketData[i].marketData['setMessage'] = false;
      }
      if (this.marketData[i].marketData.numberOfResponse > 0 && this.marketData[i].marketData.numberOfResponse < this.lowerParameter ) {
        this.marketData[i].veryLowSampleSize = true;
      }
      else {
        this.marketData[i].veryLowSampleSize = false;
      }
      if(this.appliedFilterList !== undefined && this.appliedFilterList.length > 0) {
        this.marketData[i].marketData.appliedFilterList = this.appliedFilterList;
      }
      this.highChartSubscrition = this.marketDataChartGenerator
        .generateChartJSON(this.marketData[i].marketData)
        .subscribe((chartJSON: any) => {
          this.marketData[i].ChartJSON = chartJSON;
          this.ref.detectChanges();
        });
      // });
    });
    delete this.marketData[i].marketData.userFilteredData;
    delete this.marketData[i].marketData.userFilteredDataCN;
    this.ref.detectChanges();
  }
  chartFilterApplied(filterdData?: any, i?: any) {
    this.marketData[i].ChartJSON = [];
    this.marketDataChartGenerator.generateChartJSON(filterdData).subscribe((chartJSON: any) => {
      this.marketData[i].ChartJSON = chartJSON;
      this.marketData[i].numberOfResponse = filterdData.numberOfResponse;
      this.ref.detectChanges();
    });
  }
  countrySelection(countryId: string, countryName, j, index, event) {
    this.backUpdata(j);
    this.updateBackupCheckedStatus(j, 'country', event.srcElement.checked, index);
    if (event.srcElement.checked) {
      if (!this.marketData[j].marketData.userFilteredData) {
        this.marketData[j].marketData.userFilteredData = $.extend(true, {}, this.filteredID);
        this.marketData[j].marketData.userFilteredDataCN = $.extend(true, {}, this.filteredName);
      }
      this.marketData[j].marketData.userFilteredData.countryId.push(countryId);
      this.marketData[j].marketData.userFilteredDataCN.countryName.push(countryName);
      this.marketData[j].marketData.userFilteredDataCountryNameValue = this.marketData[j].marketData.userFilteredDataCN.countryName.join();
      this.marketData[j].marketData.userFilters.country[index].status = true;
      //test start
      // API call to automatically select the countries involved in the geography
      let selectedCountryObject = _.find(this.marketData[j].marketData.userFilters.country, { 'id': countryId });

      let sameGeographyCountryList = _.filter(this.marketData[j].marketData.userFiltersBackup.country,
        { 'geographyId': selectedCountryObject.geographyId }
      );

      let sameGeographySelectedCountryList = _.filter(this.marketData[j].marketData.userFiltersBackup.country,
        { 'geographyId': selectedCountryObject.geographyId, 'status': true }
      );
      if (sameGeographyCountryList.length === sameGeographySelectedCountryList.length) {
        let autoSelectedGeographyId = selectedCountryObject.geographyId;
        let geographyObject = _.find(this.marketData[j].marketData.userFilters.geography,
          { 'id': autoSelectedGeographyId }
        );
        // below is the code to check it as true where geography with autoSelectedGeographyId 
        this.marketData[j].marketData.userFilteredData.geographyId.push(autoSelectedGeographyId);
        this.marketData[j].marketData.userFilteredDataCN.geographyName.push(geographyObject.geographicTitle);
        this.marketData[j].marketData.userFilteredDatageographyNameValue =
          this.marketData[j].marketData.userFilteredDataCN.geographyName.join();

        _.map(this.marketData[j].marketData.userFilters.geography, (geographyObj) => {
          if (geographyObj.id === autoSelectedGeographyId) {
            geographyObj.status = true;
          }
        });
      }
      //test ends
    } else if (_.includes(this.marketData[j].marketData.userFilteredData.countryId, countryId)) {
      _.pull(this.marketData[j].marketData.userFilteredData.countryId, countryId);
      _.pull(this.marketData[j].marketData.userFilteredDataCN.countryName, countryName);
      this.marketData[j].marketData.userFilteredDataCountryNameValue = this.marketData[j].marketData.userFilteredDataCN.countryName.join();
      this.marketData[j].marketData.userFilters.country[index].status = false;
      if (this.marketData[j].marketData.userFilteredDataCN.countryName.length == 0) {
        delete this.marketData[j].marketData.userFilteredDataCountryNameValue;
      }
      // checking wheather any geography is selected
      if (this.marketData[j].marketData.userFilteredData.geographyId) {
        _.forEach(this.marketData[j].marketData.userFilteredData.geographyId, (elemId) => {
          this.rolesSharedService.getGeographicalResponsibilities(elemId).subscribe(
            (response) => {
              const resp = response;
              _.forEach(resp, (respElement) => {
                this.countryIdArray.push(respElement.countryId);

              });
              // remove the selection of the geography if country deselected belongs to the geography
              if (this.countryIdArray.includes(countryId)) {
                _.forEach(this.marketData[j].marketData.userFilters.geography, (elem) => {
                  if (elem.id === elemId) {
                    elem.status = false;
                  }

                });
                _.pull(this.marketData[j].marketData.userFilteredData.geographyId, elemId);
                let geographyObject = _.find(this.marketData[j].marketData.userFilters.geography,
                  { 'id': elemId }
                );
                _.pull(this.marketData[j].marketData.userFilteredDataCN.geographyName,
                  geographyObject.geographicTitle
                );

              }
              this.countryIdArray = [];

            }
          );

        });
      }
    }

  }
  solutionSelection(subTechDomainId: string, subDomainName, j, index, event) {
    this.backUpdata(j);
    if (event.srcElement.checked) {
      if (!this.marketData[j].marketData.userFilteredData) {
        this.marketData[j].marketData.userFilteredData = $.extend(true, {}, this.filteredID);
        this.marketData[j].marketData.userFilteredDataCN = $.extend(true, {}, this.filteredName);
      }
      this.marketData[j].marketData.userFilteredData.subTechDomainId.push(subTechDomainId);
      this.marketData[j].marketData.userFilteredDataCN.subDomainName.push(subDomainName);
      this.marketData[j].marketData.userFilteredDataSubDomainNameValue = this.marketData[j].marketData.userFilteredDataCN.subDomainName.join();
      this.marketData[j].marketData.userFilters.solutions[index].status = true;
      if (this.marketData[j].marketData.userFilteredDataCN.subDomainName.length != 0) {
        this.marketData[j].marketData.solutionCheckDataflag = true;
        this.marketData[j].marketData.customQuestionCheckFlag = this.marketData[j].marketData.customQuestionCheckFlag ? this.marketData[j].marketData.customQuestionCheckFlag : false;
        // this.solutionCheckDataflag=true;
      }
      const solFlag = this.marketData[j].marketData.solutionCheckDataflag;
      if (solFlag === false || solFlag === undefined) {
        this.marketData[j].marketData.disableFlag = false;
      } else if (solFlag === true && (this.selectedDistinctCustomQuestions.length === this.marketData[j].marketData.solutionQuestionFilterConfiguration.length)) {
        this.marketData[j].marketData.disableFlag = false;
      } else {
        this.marketData[j].marketData.disableFlag = true;
      }
    } else {
      // this.solutionCheckDataflag=false;
      if (this.marketData[j].marketData.userFilteredData) {
        if (_.includes(this.marketData[j].marketData.userFilteredData.subTechDomainId, subTechDomainId)) {
          _.pull(this.marketData[j].marketData.userFilteredData.subTechDomainId, subTechDomainId);
          _.pull(this.marketData[j].marketData.userFilteredDataCN.subDomainName, subDomainName);
          this.marketData[j].marketData.userFilteredDataSubDomainNameValue = this.marketData[j].marketData.userFilteredDataCN.subDomainName.join();
          this.marketData[j].marketData.userFilters.solutions[index].status = false;
        }
        if (this.marketData[j].marketData.userFilteredDataCN.subDomainName.length == 0) {
          delete this.marketData[j].marketData.userFilteredDataSubDomainNameValue;
        }
        if (this.marketData[j].marketData.userFilteredDataCN.subDomainName.length == 0) {
          // this.solutionCheckDataflag=false;
          this.marketData[j].marketData.solutionCheckDataflag = false;
        }
      }
      const solFlag = this.marketData[j].marketData.solutionCheckDataflag;
      if (solFlag === false || solFlag === undefined) {
        this.marketData[j].marketData.disableFlag = false;
      } else if (solFlag === true && (this.selectedDistinctCustomQuestions.length === this.marketData[j].marketData.solutionQuestionFilterConfiguration.length)) {
        this.marketData[j].marketData.disableFlag = false;
      } else {
        this.marketData[j].marketData.disableFlag = true;
      }
    }
    this.updateBackupCheckedStatus(j, 'solutions', event.srcElement.checked, index);

    //  else {
    // }
  }


  employeeSizeSelection(employeeSizeId, to, from, j, index, event) {
    this.backUpdata(j);
    this.employeeSizelabel = to + '-' + from;
    if (event.srcElement.checked) {
      if (!this.marketData[j].marketData.userFilteredData) {
        this.marketData[j].marketData.userFilteredData = $.extend(true, {}, this.filteredID);
        this.marketData[j].marketData.userFilteredDataCN = $.extend(true, {}, this.filteredName);
      }
      this.marketData[j].marketData.userFilters.employeeSize[index].status = true;
      this.marketData[j].marketData.userFilteredData.employeeSizeId.push(employeeSizeId);
      this.marketData[j].marketData.userFilteredDataCN.employeeSizeName.push(this.employeeSizelabel);
      this.marketData[j].marketData.userFilteredDataEmployeeValue;
      this.marketData[j].marketData.userFilteredDataEmployeeValue = this.marketData[j].marketData.userFilteredDataCN.employeeSizeName.join();
    } else if (_.includes(this.marketData[j].marketData.userFilteredData.employeeSizeId, employeeSizeId)) {
      _.pull(this.marketData[j].marketData.userFilteredData.employeeSizeId, employeeSizeId);

      _.pull(this.marketData[j].marketData.userFilteredDataCN.employeeSizeName, this.employeeSizelabel);
      this.marketData[j].marketData.userFilteredDataEmployeeValue = this.marketData[j].marketData.userFilteredDataCN.employeeSizeName.join();
      this.marketData[j].marketData.userFilters.employeeSize[index].status = false;
      if (this.marketData[j].marketData.userFilteredDataCN.employeeSizeName.length == 0) {
        delete this.marketData[j].marketData.userFilteredDataEmployeeValue;
      }
    }
    this.updateBackupCheckedStatus(j, 'employeeSize', event.srcElement.checked, index);

  }

  geographySelection(geographyId, geographyName, j, index, event) {
    this.backUpdata(j);
    if (event.srcElement.checked) {
      if (!this.marketData[j].marketData.userFilteredData) {
        this.marketData[j].marketData.userFilteredData = $.extend(true, {}, this.filteredID);
        this.marketData[j].marketData.userFilteredDataCN = $.extend(true, {}, this.filteredName);
      }
      this.marketData[j].marketData.userFilteredData.geographyId.push(geographyId);
      this.marketData[j].marketData.userFilteredDataCN.geographyName.push(geographyName);
      this.marketData[j].marketData.userFilteredDatageographyNameValue;
      this.marketData[j].marketData.userFilteredDatageographyNameValue = this.marketData[j].marketData.userFilteredDataCN.geographyName.join();
      this.marketData[j].marketData.userFilters.geography[index].status = true;
      // API call to automatically select the countries involved in the geography
      this.rolesSharedService.getGeographicalResponsibilities(geographyId).subscribe(
        (response) => {
          // console.log(response);
          this.geographyResponse = response;
          _.forEach(this.geographyResponse, (element) => {
            _.forEach(this.marketData[j].marketData.userFilters.country, (elem) => {
              if (element.countryId === elem.id) {
                elem.status = true;
                // this.marketData[j].marketData.userFilteredData.countryId.push(elem.id);
              }
            });
            _.forEach(this.marketData[j].marketData.userFiltersBackup.country, (countryObj) => {
              if (element.countryId === countryObj.id) {
                countryObj.status = true;
                this.marketData[j].marketData.userFilteredData.countryId.push(countryObj.id);
                this.marketData[j].marketData.userFilteredDataCN.countryName.push(countryObj.countryName);
                this.marketData[j].marketData.userFilteredData.countryId = 
                  _.uniqWith(this.marketData[j].marketData.userFilteredData.countryId, _.isEqual);
                this.marketData[j].marketData.userFilteredDataCN.countryName = 
                  _.uniqWith(this.marketData[j].marketData.userFilteredDataCN.countryName, _.isEqual);
                this.marketData[j].marketData.userFilteredDataCountryNameValue = this.marketData[j].marketData.userFilteredDataCN.countryName.join();
              }
            });
          });
        });
    } else if (_.includes(this.marketData[j].marketData.userFilteredData.geographyId, geographyId)) {
      _.pull(this.marketData[j].marketData.userFilteredData.geographyId, geographyId);
      _.pull(this.marketData[j].marketData.userFilteredDataCN.geographyName, geographyName);
      this.marketData[j].marketData.userFilteredDatageographyNameValue = this.marketData[j].marketData.userFilteredDataCN.geographyName.join();
      this.marketData[j].marketData.userFilters.geography[index].status = false;
      if (this.marketData[j].marketData.userFilteredDataCN.geographyName.length == 0) {
        delete this.marketData[j].marketData.userFilteredDatageographyNameValue;
      }
      // API call to  deselect the countries involved in the geography
      this.rolesSharedService.getGeographicalResponsibilities(geographyId).subscribe(
        (response) => {
          // console.log(response);
          this.geographyResponse = response;
          _.forEach(this.geographyResponse, (element) => {
            _.forEach(this.marketData[j].marketData.userFilters.country, (elem) => {
              if (element.countryId === elem.id) {
                elem.status = false;
                _.pull(this.marketData[j].marketData.userFilteredData.countryId, elem.id);
              }
              _.forEach(this.marketData[j].marketData.userFiltersBackup.country, (countryObj) => {
                if (element.countryId === countryObj.id) {
                  countryObj.status = false;
                  _.pull(this.marketData[j].marketData.userFilteredData.countryId, countryObj.id);
                  _.pull(this.marketData[j].marketData.userFilteredDataCN.countryName, countryObj.countryName);
                  this.marketData[j].marketData.userFilteredDataCountryNameValue = this.marketData[j].marketData.userFilteredDataCN.countryName.join();
                }
              });
            });
          });
        });
    }
    this.updateBackupCheckedStatus(j, 'geography', event.srcElement.checked, index);
  }

  industrySelection(industryId, industryName, j, index, event) {
    this.backUpdata(j);
    if (event.srcElement.checked) {
      if (!this.marketData[j].marketData.userFilteredData) {
        this.marketData[j].marketData.userFilteredData = $.extend(true, {}, this.filteredID);
        this.marketData[j].marketData.userFilteredDataCN = $.extend(true, {}, this.filteredName);
      }
      this.marketData[j].marketData.userFilteredData.industryId.push(industryId);
      this.marketData[j].marketData.userFilteredDataCN.industryName.push(industryName);
      this.marketData[j].marketData.userFilteredDataindustryNameValue;
      this.marketData[j].marketData.userFilteredDataindustryNameValue = this.marketData[j].marketData.userFilteredDataCN.industryName.join();
      this.marketData[j].marketData.userFilters.industry[index].status = true;

      // select the industry cluster if the selected industries belongs to that cluster
      _.forEach(this.marketData[j].marketData.customUserProfileFilters, (element) => {
        _.forEach(element.profileData, (elem) => {
          this.profileFilterArray = elem.dataId;
          let preSelectedData = this.marketData[j].marketData.userFilteredData.industryId;
          if (this.profileFilterArray.includes(industryId)) {
            if (preSelectedData) {
              let isNeedtoSelectData = true;
              this.profileFilterArray.forEach(y => {
                if (preSelectedData.includes(y) == false) {
                  isNeedtoSelectData = false;
                }
              });
              if (isNeedtoSelectData) {
                elem.status = true;
              }
            }
          }

        });
      });

    } else if (_.includes(this.marketData[j].marketData.userFilteredData.industryId, industryId)) {
      _.pull(this.marketData[j].marketData.userFilteredData.industryId, industryId);
      _.pull(this.marketData[j].marketData.userFilteredDataCN.industryName, industryName);
      this.marketData[j].marketData.userFilteredDataindustryNameValue = this.marketData[j].marketData.userFilteredDataCN.industryName.join();
      this.marketData[j].marketData.userFilters.industry[index].status = false;
      if (this.marketData[j].marketData.userFilteredDataCN.industryName.length == 0) {
        delete this.marketData[j].marketData.userFilteredDataindustryNameValue;
      }
      //  deselect any industry clusture if the deselected industry belongs to that cluster
      _.forEach(this.marketData[j].marketData.customUserProfileFilters, (element) => {
        _.forEach(element.profileData, (elem) => {
          this.profileFilterArray = elem.dataId;
          if (this.profileFilterArray.includes(industryId)) {
            const filteredArray = this.profileFilterArray.map(x => x !== industryId);

            elem.status = false;

          }

        });
      });

    }
    this.updateBackupCheckedStatus(j, 'industry', event.srcElement.checked, index);

  }

  itBudgetSelection(itBudgetId, label, to, from, j, index, event) {
    this.backUpdata(j);
    if (label) {
      this.itBudgetSelectionLabel = label;
    } else {
      this.itBudgetSelectionLabel = to + '-' + from;

    }
    if (event.srcElement.checked) {
      if (!this.marketData[j].marketData.userFilteredData) {
        this.marketData[j].marketData.userFilteredData = $.extend(true, {}, this.filteredID);
        this.marketData[j].marketData.userFilteredDataCN = $.extend(true, {}, this.filteredName);
      }
      this.marketData[j].marketData.userFilteredData.itBudgetId.push(itBudgetId);
      this.marketData[j].marketData.userFilteredDataCN.itBudgetName.push(this.itBudgetSelectionLabel);
      this.marketData[j].marketData.userFilteredDataitBudgetNameValue;
      this.marketData[j].marketData.userFilteredDataitBudgetNameValue = this.marketData[j].marketData.userFilteredDataCN.itBudgetName.join();
      this.marketData[j].marketData.userFilters.itBudget[index].status = true;
    } else if (_.includes(this.marketData[j].marketData.userFilteredData.itBudgetId, itBudgetId)) {
      _.pull(this.marketData[j].marketData.userFilteredData.itBudgetId, itBudgetId);
      _.pull(this.marketData[j].marketData.userFilteredDataCN.itBudgetName, this.itBudgetSelectionLabel);
      this.marketData[j].marketData.userFilteredDataitBudgetNameValue = this.marketData[j].marketData.userFilteredDataCN.itBudgetName.join();
      this.marketData[j].marketData.userFilters.itBudget[index].status = false;
      if (this.marketData[j].marketData.userFilteredDataCN.itBudgetName.length == 0) {
        delete this.marketData[j].marketData.userFilteredDataitBudgetNameValue;
      }
    }
    this.updateBackupCheckedStatus(j, 'itBudget', event.srcElement.checked, index);
  }

  jobTitleSelection(jobTitleId, jobTitleName, j, index, event) {
    this.backUpdata(j);
    if (event.srcElement.checked) {
      if (!this.marketData[j].marketData.userFilteredData) {
        this.marketData[j].marketData.userFilteredData = $.extend(true, {}, this.filteredID);
        this.marketData[j].marketData.userFilteredDataCN = $.extend(true, {}, this.filteredName);
      }
      this.marketData[j].marketData.userFilteredData.jobTitleId.push(jobTitleId);
      this.marketData[j].marketData.userFilteredDataCN.jobTitleName.push(jobTitleName);
      this.marketData[j].marketData.userFilteredDatajobTitleNameValue;
      this.marketData[j].marketData.userFilteredDatajobTitleNameValue = this.marketData[j].marketData.userFilteredDataCN.jobTitleName.join();
      this.marketData[j].marketData.userFilters.jobTitle[index].status = true;
    } else if (_.includes(this.marketData[j].marketData.userFilteredData.jobTitleId, jobTitleId)) {
      _.pull(this.marketData[j].marketData.userFilteredData.jobTitleId, jobTitleId);
      _.pull(this.marketData[j].marketData.userFilteredDataCN.jobTitleName, jobTitleName);
      this.marketData[j].marketData.userFilteredDatajobTitleNameValue = this.marketData[j].marketData.userFilteredDataCN.jobTitleName.join();
      this.marketData[j].marketData.userFilters.jobTitle[index].status = false;
      if (this.marketData[j].marketData.userFilteredDataCN.jobTitleName.length == 0) {
        delete this.marketData[j].marketData.userFilteredDatajobTitleNameValue;
      }
    }
    this.updateBackupCheckedStatus(j, 'jobTitle', event.srcElement.checked, index);
  }


  lineOfBusinessSelection(lineOfBusinessId, lineOfBusinessName, j, index, event) {
    this.backUpdata(j);
    if (event.srcElement.checked) {
      if (!this.marketData[j].marketData.userFilteredData) {
        this.marketData[j].marketData.userFilteredData = $.extend(true, {}, this.filteredID);
        this.marketData[j].marketData.userFilteredDataCN = $.extend(true, {}, this.filteredName);
      }
      this.marketData[j].marketData.userFilteredData.lineOfBusinessId.push(lineOfBusinessId);
      this.marketData[j].marketData.userFilteredDataCN.lineOfBusinessName.push(lineOfBusinessName);
      this.marketData[j].marketData.userFilteredDatalineOfBusinessNameValue;
      this.marketData[j].marketData.userFilteredDatalineOfBusinessNameValue = this.marketData[j].marketData.userFilteredDataCN.lineOfBusinessName.join();
      this.marketData[j].marketData.userFilters.lineOfBusiness[index].status = true;
    } else if (_.includes(this.marketData[j].marketData.userFilteredData.lineOfBusinessId, lineOfBusinessId)) {
      _.pull(this.marketData[j].marketData.userFilteredData.lineOfBusinessId, lineOfBusinessId);
      _.pull(this.marketData[j].marketData.userFilteredDataCN.lineOfBusinessName, lineOfBusinessName);
      this.marketData[j].marketData.userFilteredDatalineOfBusinessNameValue = this.marketData[j].marketData.userFilteredDataCN.lineOfBusinessName.join();
      this.marketData[j].marketData.userFilters.lineOfBusiness[index].status = false;
      if (this.marketData[j].marketData.userFilteredDataCN.lineOfBusinessName.length == 0) {
        delete this.marketData[j].marketData.userFilteredDatalineOfBusinessNameValue;
      }
    }
    this.updateBackupCheckedStatus(j, 'lineOfBusiness', event.srcElement.checked, index);
  }


  revenueSelection(revenueId, label, from, to, j, index, event) {
    this.backUpdata(j);
    if (event.srcElement.checked) {
      if (label) {
        this.revenueLabel = label;
      } else {
        this.revenueLabel = to + '-' + from;

      }

      if (!this.marketData[j].marketData.userFilteredData) {
        this.marketData[j].marketData.userFilteredData = $.extend(true, {}, this.filteredID);
        this.marketData[j].marketData.userFilteredDataCN = $.extend(true, {}, this.filteredName);
      }
      this.marketData[j].marketData.userFilteredData.globalRevenueId.push(revenueId);
      this.marketData[j].marketData.userFilteredDataCN.globalRevenueName.push(this.revenueLabel);
      this.marketData[j].marketData.userFilteredDatarevenueNameValue = this.marketData[j].marketData.userFilteredDataCN.globalRevenueName.join();
      this.marketData[j].marketData.userFilters.revenue[index].status = true;
    } else if (_.includes(this.marketData[j].marketData.userFilteredData.globalRevenueId, revenueId)) {
      _.pull(this.marketData[j].marketData.userFilteredData.globalRevenueId, revenueId);
      _.pull(this.marketData[j].marketData.userFilteredDataCN.globalRevenueName, this.revenueLabel);
      this.marketData[j].marketData.userFilteredDatarevenueNameValue = this.marketData[j].marketData.userFilteredDataCN.globalRevenueName.join();
      this.marketData[j].marketData.userFilters.revenue[index].status = false;
      if (this.marketData[j].marketData.userFilteredDataCN.globalRevenueName.length == 0) {
        delete this.marketData[j].marketData.userFilteredDatarevenueNameValue;
      }
    }
  }

  choiceChecked(mIndex, qIndex) {
    let isChoiceChecked = false;
    const choiceList = this.marketData[mIndex].marketData.customQuestionFiltersBackup[qIndex].choiceId;
    isChoiceChecked = _.some(choiceList, { 'status': true });
    return isChoiceChecked;
  }

  choiceQuestionChecked(mIndex, qIndex) {
    let isChoiceChecked = false;
    const choiceList = this.marketData[mIndex].marketData.customQuestionFiltersBackup[qIndex].customChoiceFilter;
    isChoiceChecked = _.some(choiceList, { 'status': true });
    return isChoiceChecked;
  }
  profileChoiceChecked(mIndex, qIndex) {
    let isChoiceChecked = false;
    const choiceList = this.marketData[mIndex].marketData.customUserProfileFiltersBackup[qIndex].profileData;
    isChoiceChecked = _.some(choiceList, { 'status': true });
    return isChoiceChecked;
  }

  choiceFilterSelectionold(qIndex, cIndex, j, index, event, isVendor?) {
    this.backUpdata(j);
    // for isVendor true radio button case, event.srcElement.checked will be always true.
    let checkedStatus = undefined;
    if (event.srcElement.checked) {
      // this.customQuestionCheckFlag = true; 
      this.marketData[j].marketData.customQuestionFilters[qIndex].status = true;
      if (isVendor === true) {
        let currentCheckedStatus = this.marketData[j].marketData.customQuestionFilters[qIndex].choiceId[cIndex].status;
        _.forEach(this.marketData[j].marketData.customQuestionFilters[qIndex].choiceId, (choiceObj) => {
          choiceObj.status = false;
        });
        if (currentCheckedStatus === true) {
          checkedStatus = false;
          this.marketData[j].marketData.customQuestionFilters[qIndex].choiceId[cIndex].status = false;
        }
        else {
          // because customQuestionFiltersBackup has the latest updated data; somehow.
          // so not updating it here.
          checkedStatus = true;
          this.marketData[j].marketData.customQuestionFilters[qIndex].choiceId[cIndex].status = true;
        }
      }
      else {
        this.marketData[j].marketData.customQuestionFilters[qIndex].choiceId[cIndex].status = true;
      }
      // if(this.marketData[j].marketData.customQuestionFilters[qIndex].label === 'Adoption Status' &&
      // this.marketData[j].marketData.customQuestionFilters[qIndex].status === true) {
      //   this.marketData[j].marketData.customQuestionCheckFlag = true;
      // }
      // for considering custom question filters and solution filter both selected, otherwise cannot submit.
      if (this.marketData[j].marketData.solutionQuestionFilterConfiguration.length > 0) {
        // this.marketData[j].marketData.solutionQuestionFilterConfiguration.forEach((setVendorQuestion)=> {
        //   if((setVendorQuestion.questionId === this.marketData[j].marketData.customQuestionFilters[qIndex].questionId)
        //    && (this.marketData[j].marketData.customQuestionFilters[qIndex].status === true)) {
        //     this.marketData[j].marketData.customQuestionCheckFlag = true;
        //   }
        // });
        let questionSolutionMaping = _.find(this.marketData[j].marketData.solutionQuestionFilterConfiguration,
          { 'questionId': this.marketData[j].marketData.customQuestionFilters[qIndex].questionId });
        let questionSolutionMapingIndex = _.findIndex(this.marketData[j].marketData.solutionQuestionFilterConfiguration,
          { 'questionId': this.marketData[j].marketData.customQuestionFilters[qIndex].questionId });
        // will update checkedQuestionFilter flag only if that is present in solutionQuestionFilterConfiguration
        if (questionSolutionMaping) {
          const selectedChoiceArr = _.filter(this.marketData[j].marketData.customQuestionFilters[qIndex].choiceId, { 'status': true });
          if (selectedChoiceArr.length > 0) {
            this.marketData[j].marketData.customQuestionFilters[qIndex].checkedQuestionFilter = true;
          } else {
            this.marketData[j].marketData.customQuestionFilters[qIndex].checkedQuestionFilter = false;
          }
        } else {
          this.marketData[j].marketData.customQuestionFilters[qIndex].checkedQuestionFilter = false;
        }
        this.selectedDistinctCustomQuestions =
          _.filter(this.marketData[j].marketData.customQuestionFilters, { 'checkedQuestionFilter': true });
        this.marketData[j].marketData.selectedDistinctCustomQuestionLength = this.selectedDistinctCustomQuestions.length;
        this.marketData[j].marketData.solutionQuestionFilterConfigurationLength = this.marketData[j].marketData.solutionQuestionFilterConfiguration.length;
        if (this.selectedDistinctCustomQuestions.length === this.marketData[j].marketData.solutionQuestionFilterConfiguration.length) {
          this.marketData[j].marketData.customQuestionCheckFlag = true;
        } else {
          this.marketData[j].marketData.customQuestionCheckFlag = false;
        }
        // if length of filter this.marketData[j].marketData.customQuestionFilters with checkedQuestionFilter = true;
        // is equal to length of this.marketData[j].marketData.solutionQuestionFilterConfiguration
        // then all selected.
        // else not
        const solFlag = this.marketData[j].marketData.solutionCheckDataflag;
        if (solFlag === false || solFlag === undefined) {
          this.marketData[j].marketData.disableFlag = false;
        } else if (solFlag === true && (this.selectedDistinctCustomQuestions.length === this.marketData[j].marketData.solutionQuestionFilterConfiguration.length)) {
          this.marketData[j].marketData.disableFlag = false;
        } else {
          this.marketData[j].marketData.disableFlag = true;
        }
      }
      if (this.marketData[j].marketData.customFilteredLabelsAdoption === undefined) {
        this.marketData[j].marketData.customFilteredLabelsAdoption = [];
      }
      this.marketData[j].marketData.customFilteredLabelsAdoption.push(
        this.marketData[j].marketData.customQuestionFilters[qIndex].choiceId[cIndex]['text']
      );
      this.marketData[j].marketData.customFilteredChoiceNameValueAdoption =
        this.marketData[j].marketData.customFilteredLabelsAdoption.join();
    } else {
      _.pull(this.marketData[j].marketData.customFilteredLabelsAdoption, this.marketData[j].marketData.customQuestionFilters[qIndex].choiceId[cIndex]['text']);
      this.marketData[j].marketData.customFilteredChoiceNameValueAdoption =
        this.marketData[j].marketData.customFilteredLabelsAdoption.join();
      this.marketData[j].marketData.customQuestionFilters[qIndex].choiceId[cIndex].status = false;
      if (this.marketData[j].marketData.customFilteredLabelsAdoption.length == 0) {
        delete this.marketData[j].marketData.customFilteredChoiceNameValueAdoption;
      }
      _.forEach(this.marketData[j].marketData.customQuestionFilters, (element) => {
        const filterdCheck = _.filter(element.choiceId, { 'status': true });
        this.selectedCustomQuestionChoices.push(...filterdCheck);
        const maturityFilterdCheck = _.filter(element.customChoiceFilter, { 'status': true });
        this.selectedCustomQuestionChoices.push(...maturityFilterdCheck);
      });
      if (this.selectedCustomQuestionChoices.length == 0) {
        // this.customQuestionCheckFlag = false;
        this.marketData[j].marketData.customQuestionCheckFlag = false;
        this.marketData[j].marketData.solutionCheckDataflag = this.marketData[j].marketData.solutionCheckDataflag ? this.marketData[j].marketData.solutionCheckDataflag : false;
      }
      else {
        _.forEach(this.marketData[j].marketData.customQuestionFilters, (element) => {
          const filterdCheck = _.filter(element.choiceId, { 'status': false });
          _.pull(this.selectedCustomQuestionChoices, ...filterdCheck);
          // this.selectedCustomQuestionChoices.push(...filterdCheck);
          const maturityFilterdCheck = _.filter(element.customChoiceFilter, { 'status': false });
          _.pull(this.selectedCustomQuestionChoices, ...maturityFilterdCheck);
          // this.selectedCustomQuestionChoices.push(...maturityFilterdCheck);
        });
        // this.selectedCustomQuestionChoices = [];
        // this.customQuestionCheckFlag = true;
        const adoptionChoiceIds = [];
        const selectedChoiceIds = [];
        _.forEach(this.marketData[j].marketData.customQuestionFilters[qIndex].choiceId, (el) => {
          adoptionChoiceIds.push(el.id);
        });
        _.forEach(this.selectedCustomQuestionChoices, (el) => {
          selectedChoiceIds.push(el.id);
        });
        // this.marketData[j].marketData.solutionQuestionFilterConfiguration.forEach((setVendorQuestion)=> {
        //   if((setVendorQuestion.questionId === this.marketData[j].marketData.customQuestionFilters[qIndex].questionId)
        //    && (this.marketData[j].marketData.customQuestionFilters[qIndex].status === true)) {
        //     if (_.intersection(adoptionChoiceIds,selectedChoiceIds).length > 0){
        //       this.marketData[j].marketData.customQuestionCheckFlag = true;
        //     } else{
        //       this.marketData[j].marketData.customQuestionCheckFlag = false;
        //     }
        //   }
        //   else {
        //     this.marketData[j].marketData.customQuestionCheckFlag = true;
        //   }
        // });
        //   if(this.marketData[j].marketData.customQuestionFilters[qIndex].label === 'Adoption Status' &&
        // this.marketData[j].marketData.customQuestionFilters[qIndex].status === true) {
        //   if (_.intersection(adoptionChoiceIds,selectedChoiceIds).length > 0){
        //     this.marketData[j].marketData.customQuestionCheckFlag = true;
        //   } else{
        //     this.marketData[j].marketData.customQuestionCheckFlag = false;
        //   }
        // } 
        // else {
        //   this.marketData[j].marketData.customQuestionCheckFlag = true;
        // }
      }
      if (this.marketData[j].marketData.solutionQuestionFilterConfiguration.length > 0) {
        // this.marketData[j].marketData.solutionQuestionFilterConfiguration.forEach((setVendorQuestion)=> {
        //   if((setVendorQuestion.questionId === this.marketData[j].marketData.customQuestionFilters[qIndex].questionId)
        //    && (this.marketData[j].marketData.customQuestionFilters[qIndex].status === true)) {
        //     this.marketData[j].marketData.customQuestionCheckFlag = true;
        //   }
        // });
        let questionSolutionMaping = _.find(this.marketData[j].marketData.solutionQuestionFilterConfiguration,
          { 'questionId': this.marketData[j].marketData.customQuestionFilters[qIndex].questionId });
        let questionSolutionMapingIndex = _.findIndex(this.marketData[j].marketData.solutionQuestionFilterConfiguration,
          { 'questionId': this.marketData[j].marketData.customQuestionFilters[qIndex].questionId });
        // will update checkedQuestionFilter flag only if that is present in solutionQuestionFilterConfiguration
        if (questionSolutionMaping) {
          const selectedChoiceArr = _.filter(this.marketData[j].marketData.customQuestionFilters[qIndex].choiceId, { 'status': true });
          if (selectedChoiceArr.length > 0) {
            this.marketData[j].marketData.customQuestionFilters[qIndex].checkedQuestionFilter = true;
          } else {
            this.marketData[j].marketData.customQuestionFilters[qIndex].checkedQuestionFilter = false;
          }
        } else {
          this.marketData[j].marketData.customQuestionFilters[qIndex].checkedQuestionFilter = false;
        }
        this.selectedDistinctCustomQuestions =
          _.filter(this.marketData[j].marketData.customQuestionFilters, { 'checkedQuestionFilter': true });
        this.marketData[j].marketData.selectedDistinctCustomQuestionLength = this.selectedDistinctCustomQuestions.length;
        this.marketData[j].marketData.solutionQuestionFilterConfigurationLength = this.marketData[j].marketData.solutionQuestionFilterConfiguration.length;
        if (this.selectedDistinctCustomQuestions.length === this.marketData[j].marketData.solutionQuestionFilterConfiguration.length) {
          this.marketData[j].marketData.customQuestionCheckFlag = true;
        } else {
          this.marketData[j].marketData.customQuestionCheckFlag = false;
        }
        // if length of filter this.marketData[j].marketData.customQuestionFilters with checkedQuestionFilter = true;
        // is equal to length of this.marketData[j].marketData.solutionQuestionFilterConfiguration
        // then all selected.
        // else not
        const solFlag = this.marketData[j].marketData.solutionCheckDataflag;
        if (solFlag === false || solFlag === undefined) {
          this.marketData[j].marketData.disableFlag = false;
        } else if (solFlag === true && (this.selectedDistinctCustomQuestions.length === this.marketData[j].marketData.solutionQuestionFilterConfiguration.length)) {
          this.marketData[j].marketData.disableFlag = false;
        } else {
          this.marketData[j].marketData.disableFlag = true;
        }
      }
    }
    if (!this.marketData[j].marketData.userFilteredData) {
      this.marketData[j].marketData.userFilteredData = $.extend(true, {}, this.filteredID);
      this.marketData[j].marketData.userFilteredDataCN = $.extend(true, {}, this.filteredName);
    }
    if (checkedStatus === undefined) {
      checkedStatus = event.srcElement.checked;
    }
    this.updateBackupCheckedStatus(j, 'customQuestionFilters', checkedStatus, cIndex, qIndex);
    // this.marketData[j].marketData.userFilteredData['customQuestionFilters'] = this.getAppliedQuestionFiltersOld(j);
    this.previousSelectedQuestionFilter[j] = [];
    this.previousSelectedQuestionFilter[j] = this.getAppliedQuestionFiltersOld(j);
    
    this.combineQuestionFilter(j);
  }
  profileFilterSelection(qIndex, cIndex, j, index, event) {
    this.backUpdata(j);
    if (!this.marketData[j].marketData.userFilteredData) {
      this.marketData[j].marketData.userFilteredData = $.extend(true, {}, this.filteredID);
      this.marketData[j].marketData.userFilteredDataCN = $.extend(true, {}, this.filteredName);
    }
    if (event.srcElement.checked) {
      this.marketData[j].marketData.customUserProfileFilters[qIndex].status = true;
      this.marketData[j].marketData.customUserProfileFilters[qIndex].profileData[cIndex].status = true;
      this.profileFilterArray = this.marketData[j].marketData.customUserProfileFilters[qIndex].profileData[cIndex].dataId;
      // check wheather any industry cluster is selected
      _.forEach(this.marketData[j].marketData.userFilters.industry, (element) => {
        if (this.profileFilterArray.includes(element.id)) {
          element.status = true;
        }
      });
      _.forEach(this.marketData[j].marketData.userFiltersBackup.industry, (element) => {
        if (this.profileFilterArray.includes(element.id)) {
          this.marketData[j].marketData.userFilteredData.industryId.push(element.id);
          this.marketData[j].marketData.userFilteredDataCN.industryName.push(element.industryName);
          this.marketData[j].marketData.userFilteredData.industryId = 
            _.uniqWith(this.marketData[j].marketData.userFilteredData.industryId, _.isEqual);
          this.marketData[j].marketData.userFilteredDataCN.industryName = 
            _.uniqWith(this.marketData[j].marketData.userFilteredDataCN.industryName, _.isEqual);
          this.marketData[j].marketData.userFilteredDataindustryNameValue = this.marketData[j].marketData.userFilteredDataCN.industryName.join();
          element.status = true;
        }
      });
    } else {
      this.marketData[j].marketData.customUserProfileFilters[qIndex].profileData[cIndex].status = false;
      this.profileFilterArray = this.marketData[j].marketData.customUserProfileFilters[qIndex].profileData[cIndex].dataId;
      // deselect any  selected industry cluster
      _.forEach(this.marketData[j].marketData.userFilters.industry, (element) => {
        if (this.profileFilterArray.includes(element.id)) {
          element.status = false;
        }
      });
      _.forEach(this.marketData[j].marketData.userFiltersBackup.industry, (element) => {
        if (this.profileFilterArray.includes(element.id)) {
          _.pull(this.marketData[j].marketData.userFilteredData.industryId, element.id);
          _.pull(this.marketData[j].marketData.userFilteredDataCN.industryName, element.industryName);
          this.marketData[j].marketData.userFilteredDataindustryNameValue = this.marketData[j].marketData.userFilteredDataCN.industryName.join();    
          element.status = false;
        }
      });
    }
    this.profileFilterArray = [];
    this.setProfileCusterData(this.getAppliedProfileFilters(j), j, this.marketData[j].marketData.customUserProfileFilters[qIndex].userProfileData);
    this.updateBackupCheckedStatus(j, 'customUserProfileFilters', event.srcElement.checked, cIndex, qIndex);
  }

  choiceFilterSelection(qIndex, cIndex, j, index, event, isVendor?) {
    this.backUpdata(j);
    let checkedStatus = undefined;
    if (event.srcElement.checked) {
      // this.customQuestionCheckFlag = true;
      // this.marketData[j].marketData.customQuestionCheckFlag = true;
      this.marketData[j].marketData.customQuestionFilters[qIndex].status = true;
      this.marketData[j].marketData.customQuestionFilters[qIndex].customChoiceFilter[cIndex].status = true;
      if (isVendor === true) {
        let currentCheckedStatus = this.marketData[j].marketData.customQuestionFilters[qIndex].customChoiceFilter[cIndex].status;
        _.forEach(this.marketData[j].marketData.customQuestionFilters[qIndex].customChoiceFilter, (choiceObj) => {
          choiceObj.status = false;
        });
        if (currentCheckedStatus === true) {
          checkedStatus = false;
          this.marketData[j].marketData.customQuestionFilters[qIndex].customChoiceFilter[cIndex].status = false;
        }
        else {
          // because customQuestionFiltersBackup has the latest updated data; somehow.
          // so not updating it here.
          checkedStatus = true;
          this.marketData[j].marketData.customQuestionFilters[qIndex].customChoiceFilter[cIndex].status = true;
        }
        // if (this.marketData[j].marketData.customQuestionFilters[qIndex].customChoiceFilter[cIndex].status === true) {
        //   this.marketData[j].marketData.customQuestionFilters[qIndex].customChoiceFilter[cIndex].status = false;
        // }
        // else {
        //   this.marketData[j].marketData.customQuestionFilters[qIndex].customChoiceFilter[cIndex].status = true;
        // }
        // _.forEach(this.marketData[j].marketData.customQuestionFilters[qIndex].customChoiceFilter, (choiceObj) => {
        //   let index = _.findIndex(this.marketData[j].marketData.customQuestionFilters[qIndex].customChoiceFilter, choiceObj);
        //   if (index !== cIndex) {
        //      choiceObj.status = false;
        //   }
        // })
      }
      else {
        this.marketData[j].marketData.customQuestionFilters[qIndex].customChoiceFilter[cIndex].status = true;
      }
      if (this.marketData[j].marketData.customFilteredLabels == undefined) {
        this.marketData[j].marketData.customFilteredLabels = [];
      }
      this.marketData[j].marketData.customFilteredLabels.push(this.marketData[j].marketData.customQuestionFilters[qIndex].customChoiceFilter[cIndex]['label']);
      this.marketData[j].marketData.customFilteredChoiceNameValue = this.marketData[j].marketData.customFilteredLabels.join();
    } else {
      _.pull(this.marketData[j].marketData.customFilteredLabels, this.marketData[j].marketData.customQuestionFilters[qIndex].customChoiceFilter[cIndex]['label']);
      this.marketData[j].marketData.customQuestionFilters[qIndex].customChoiceFilter[cIndex].status = false;
      this.marketData[j].marketData.customFilteredChoiceNameValue = this.marketData[j].marketData.customFilteredLabels.join();
      if (this.marketData[j].marketData.customFilteredLabels.length == 0) {
        delete this.marketData[j].marketData.customFilteredChoiceNameValue;
      }
      _.forEach(this.marketData[j].marketData.customQuestionFilters, (element) => {
        const filterdCheck = _.filter(element.choiceId, { 'status': true });
        this.selectedCustomQuestionChoices.push(...filterdCheck);
        const maturityFilterdCheck = _.filter(element.customChoiceFilter, { 'status': true });
        this.selectedCustomQuestionChoices.push(...maturityFilterdCheck);
      });
      // if(this.selectedCustomQuestionChoices.length == 0){
      //   // this.customQuestionCheckFlag = false;
      //   this.marketData[j].marketData.customQuestionCheckFlag = false;
      // }
      // else{
      //   this.selectedCustomQuestionChoices =  [];
      //   // this.customQuestionCheckFlag = true;
      //   this.marketData[j].marketData.customQuestionCheckFlag = true;
      // }
    }
    if (!this.marketData[j].marketData.userFilteredData) {
      this.marketData[j].marketData.userFilteredData = $.extend(true, {}, this.filteredID);
      this.marketData[j].marketData.userFilteredDataCN = $.extend(true, {}, this.filteredName);
    }
    if (checkedStatus === undefined) {
      checkedStatus = event.srcElement.checked;
    }
    this.updateBackupCheckedStatus(j, 'customQuestionFilters', checkedStatus, cIndex, qIndex);
    this.previousSelectedClusterQuestionFilter[j] = [];
    this.previousSelectedClusterQuestionFilter[j] = this.getAppliedQuestionFilters(j);

    this.combineQuestionFilter(j);
    //this.marketData[j].marketData.userFilteredData['customQuestionFilters'] = this.getAppliedQuestionFilters(j,qIndex);

  }
  getAppliedQuestionFilters(mIndex) {
    const result = [];
    const customQuestionFilters = Object.assign([], this.marketData[mIndex].marketData.customQuestionFiltersBackup);

    _.forEach(customQuestionFilters, (filterQuestion) => {
      if (filterQuestion.customChoiceFilter) {
        const customChoiceFilter = filterQuestion.customChoiceFilter;
        _.forEach(customChoiceFilter, (filterChoice) => {
          if (filterChoice.status) {
            const selectedChoices = filterChoice.choiceData;
            if (selectedChoices.length > 0) {
              const qId = filterQuestion.questionId;
              const resultIndex = result.findIndex(x => x.questionId === qId);
              if (resultIndex > -1) {
                result[resultIndex].choiceIds = [...result[resultIndex].choiceIds, ..._.map(selectedChoices, "choiceId")];
              } else {
                result.push({
                  questionId: qId,
                  surveyId: filterChoice.surveyId ? filterChoice.surveyId : null,
                  choiceIds: _.map(selectedChoices, "choiceId"),
                });
              }
            }
          }
        });
      }
    });
    return result;
  }

  getAppliedQuestionFiltersOld(mIndex) {
    const result = [];
    const customQuestionFilters = Object.assign([], this.marketData[mIndex].marketData.customQuestionFiltersBackup);
    _.forEach(customQuestionFilters, function (filterQuestion, key) {
      // if (filterQuestion.status) {
        const selectedChoices = _.filter(filterQuestion.choiceId, { 'status': true });
        if (selectedChoices.length > 0) {
          result.push({
            surveyId: filterQuestion.surveyId ? filterQuestion.surveyId : null,
            questionId: filterQuestion.questionId,
            choiceIds: _.map(selectedChoices, "id")
          });
        }
      // }
    });
    return result;
  }
  getAppliedProfileFilters(mIndex) {
    let result = [];
    const customUserProfileFilters = Object.assign([], this.marketData[mIndex].marketData.customUserProfileFilters);
    _.forEach(customUserProfileFilters, function (filterQuestion, key) {
      if (filterQuestion.status) {
        const selectedChoices = _.filter(filterQuestion.profileData, { 'status': true });
        if (selectedChoices.length > 0) {
          selectedChoices.forEach(element => {
            result = [...result, ...element.dataId];
          });
        }
      }
    });
    return result;
  }
  combineQuestionFilter(j) {
    if (!this.previousSelectedClusterQuestionFilter[j]) {
      this.previousSelectedClusterQuestionFilter[j] = [];
    }
    if (!this.previousSelectedQuestionFilter[j]) {
      this.previousSelectedQuestionFilter[j] = [];
    }
    this.marketData[j].marketData.userFilteredData['customQuestionFilters'] = [...this.previousSelectedQuestionFilter[j], ...this.previousSelectedClusterQuestionFilter[j]];
  }
  filterApply(i) {
    this.marketData[i].isFilterApplied = true;
    this.marketData[i].marketData.apply = true;
    // Copy marketData - content object to API payload
    this.marketDataContent = this.marketData[i].marketData.content;
    // Copy applied filters to API payload
    for (const key in this.marketData[i].marketData.userFilteredData) {
      this.marketDataContent[key] = [...this.marketData[i].marketData.userFilteredData[key]];
    }
    this.marketDataContent[`marketDataId`] = this.marketData[i].marketData.id;
    this.marketDataContent[`isClustered`] = this.marketData[i].marketData.isClustered || false;
    this.marketDataContent.userBenchmark = this.marketData[i].selectedbenchMarkFilter;
    this.marketDataContent[`timeline`] = this.timeLineAnalysisFilter;
    this.marketDataContent[`isParentQuestionGraph`] = this.marketData[i].marketData.isParentQuestionGraph || false;
    this.marketDataContent[`hasSolutionFilter`] = this.marketData[i].marketData.hasSolutionFilter || false;
    this.rolesSharedService.filterMarketData(this.marketDataContent, this.marketData[i].researchDocumentId).subscribe((filteredData: any) => {
      //  this.marketData=[];
      // Update marketData graph values with response data graph values
      this.marketData[i].marketData.marketData = filteredData.data;
      // Update marketData graph numberOfResponse with response data graph numberOfResponse
      this.marketData[i].marketData.numberOfResponse = filteredData.numberOfResponse;
      // this.chartData.emit(this.marketDat.marketData);
      // this.marketData[i].marketData.ChartJSON = [];
      // this.marketDataChartGenerator.generateChartJSON(this.marketData[i].marketData).subscribe((chartJSON: any) => {
      //   this.marketData[i].marketData.ChartJSON = chartJSON;
      //   this.marketData[i].marketData.numberOfResponse = this.marketData[i].marketData.marketData.numberOfResponse;
      //   this.ref.detectChanges();
      if (this.marketData[i].marketData.numberOfResponse < this.lowerParameter) {
        this.marketData[i].marketData['setMessage'] = true;
        this.marketData[i].veryLowSampleSize = true;
      }
      else {
        this.marketData[i].veryLowSampleSize = false;
      }
      if(this.appliedFilterList !== undefined && this.appliedFilterList.length > 0) {
        this.marketData[i].marketData.appliedFilterList = this.appliedFilterList;
      }
      this.highChartSubscrition = this.marketDataChartGenerator
        .generateChartJSON(this.marketData[i].marketData)
        .subscribe((chartJSON: any) => {
          // Update marketData graph ChartJSON with response data graph ChartJSON
          this.marketData[i].ChartJSON = chartJSON;
          this.ref.detectChanges();
        });

      // });


    });
  }
  ngOnDestroy() {
  }

  isLoggedIn() {
    if (this.authenticationService.isLoggedIn()) {
      this.loggedInStatus = true;
      this.getRole();
    } else {
      this.loggedInStatus = false;
    }
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }

  navigateAllresearchPage() {
    if (this.userRole === 'tech-vendor') {
      this.router.navigate([`${this.userRole}/all-market-data`]);
    } else {
      this.router.navigate([`${this.userRole}/research/all-research`]);
    }
  }

  navigateToResearchSnapshotPage() {
    if (this.userRole === 'tech-vendor') {
      this.router.navigate([`${this.userRole}/market-data/${this.researchDataId}`]);
    } else {
      this.router.navigate([`${this.userRole}/research-snapshot/${this.researchDataId}`]);
    }
  }

  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.userId = this.userDetailsObject.userId;
    }
  }

  navigateToReport(reportId) {
    const tempSession = sessionStorage.getItem('userDetails');
    if (tempSession) {
      localStorage.setItem('tempSession', tempSession);
    }
    let webUrl = "";
    if (this.userRole === "tech-analyst") {
      webUrl = `${document.location.origin}/#/${this.userRole}/reports/report-details/${reportId}`;
    } else {
      webUrl = `${document.location.origin}/#/${this.userRole}/report-details/${reportId}`;
    }
    return webUrl;
  }
  getResearchData(researchDataId) {
    const filter: any = {};
    filter.filter = JSON.stringify({
      include: [
        { survey: { responses: "users" } },
        "domain",
        { likes: "user" },
        { comments: "user" },
        { ratings: "user" },
        { bookmark: "user" }
      ]
    });
    this.rolesSharedService
      .getResearchData(filter, researchDataId)
      .subscribe((researchData: any) => {
        
        this.titleService.setTitle('Research: ' + researchData.title || 'Ecosystm');
        var _hsq = window._hsq = window._hsq || [];
         _hsq.push(["trackEvent", {
          id: researchData.title,
          value : researchData.title
          }]); 
        _hsq.push(['trackPageView'])
        _hsq.push(['refreshPageHandlers']);

      
        if (researchData.sampleDataSize && researchData.sampleDataSize.lowerSampleSize) {
          if (researchData.sampleDataSize.lowerSampleSize.minVal && researchData.sampleDataSize.lowerSampleSize.maxVal) {
            this.lowerParameter = researchData.sampleDataSize.lowerSampleSize.minVal;
            this.upperParameter = researchData.sampleDataSize.lowerSampleSize.maxVal;
          }
        }
        if ((researchData.userProfileFilter) || (researchData.userProfileClusterFilter && researchData.userProfileClusterFilter.length > 0)) {
          this.hasMasterFilter = true;
          if (researchData.userProfileFilter) {
            if (researchData.userProfileFilter.industry) {
              let userProfileIndex = _.findIndex(this.userProfileFilter, ['type', 'industry']);
              let segmentIndex = _.findIndex(this.segmentFilteredData, ['type', 'industry']);
              if (userProfileIndex !== -1) {
                researchData.userProfileFilter.industry = (researchData.userProfileFilter.industry || []).sort((a, b) => a.industryName < b.industryName ? -1 : 1)
                this.userProfileFilter[userProfileIndex].data = researchData.userProfileFilter.industry;
                let dataArray = [];
                _.forEach(researchData.userProfileFilter.industry, (segObj) => {
                  dataArray.push({
                    id: segObj.id,
                    label: segObj.industryName
                  });
                });
                this.segmentFilteredData[segmentIndex].data = dataArray;
              }
            }
            if(researchData.userProfileFilter.it_budget) {
              let userProfileIndex = _.findIndex(this.userProfileFilter, ['type', 'it_budget']); 
              let segmentIndex = _.findIndex(this.segmentFilteredData, ['type', 'it_budget']);
              if(userProfileIndex !== -1) {
                researchData.userProfileFilter.it_budget = _.sortBy(researchData.userProfileFilter.it_budget, ['sequence']);
                this.userProfileFilter[userProfileIndex].data = researchData.userProfileFilter.it_budget;
                let dataArray = [];
                _.forEach(researchData.userProfileFilter.it_budget, (segObj) => {
                  dataArray.push({
                      id: segObj.id,
                      label: segObj.label
                  });
                });
                this.segmentFilteredData[segmentIndex].data = dataArray;
              }
            }
            if(researchData.userProfileFilter.geography) {
              let userProfileIndex = _.findIndex(this.userProfileFilter, ['type', 'geography']); 
              let segmentIndex = _.findIndex(this.segmentFilteredData, ['type', 'geography']);
              if(userProfileIndex !== -1) {
                researchData.userProfileFilter.geography = (researchData.userProfileFilter.geography || []).sort((a, b) => a.geographicTitle < b.geographicTitle ? -1 : 1)
                this.userProfileFilter[userProfileIndex].data = researchData.userProfileFilter.geography;
                let dataArray = [];
                _.forEach(researchData.userProfileFilter.geography, (segObj) => {
                  dataArray.push({
                      id: segObj.id,
                      label: segObj.geographicTitle
                  });
                });
                this.segmentFilteredData[segmentIndex].data = dataArray;
              }
            }
            if(researchData.userProfileFilter.line_of_business) {
              let userProfileIndex = _.findIndex(this.userProfileFilter, ['type', 'line_of_business']); 
              let segmentIndex = _.findIndex(this.segmentFilteredData, ['type', 'line_of_business']);
              if(userProfileIndex !== -1) {
                researchData.userProfileFilter.line_of_business = (researchData.userProfileFilter.line_of_business || []).sort((a, b) => a.lineOfBusiness < b.lineOfBusiness ? -1 : 1)
                this.userProfileFilter[userProfileIndex].data = researchData.userProfileFilter.line_of_business;
                let dataArray = [];
                _.forEach(researchData.userProfileFilter.line_of_business, (segObj) => {
                  dataArray.push({
                    id: segObj.id,
                    label: segObj.lineOfBusiness
                  });
                });
                this.segmentFilteredData[segmentIndex].data = dataArray;
              }
            }
            if(researchData.userProfileFilter.country) {
              let userProfileIndex = _.findIndex(this.userProfileFilter, ['type', 'country']); 
              let segmentIndex = _.findIndex(this.segmentFilteredData, ['type', 'country']);
              if(userProfileIndex !== -1) {
                researchData.userProfileFilter.country = (researchData.userProfileFilter.country || []).sort((a, b) => a.countryName < b.countryName ? -1 : 1)
                this.userProfileFilter[userProfileIndex].data = researchData.userProfileFilter.country;
                let dataArray = [];
                _.forEach(researchData.userProfileFilter.country, (segObj) => {
                  dataArray.push({
                    id: segObj.id,
                    label: segObj.countryName
                  });
                });
                this.segmentFilteredData[segmentIndex].data = dataArray;
              }
            }
            if(researchData.userProfileFilter.employee_size) {
              let userProfileIndex = _.findIndex(this.userProfileFilter, ['type', 'employee_size']); 
              let segmentIndex = _.findIndex(this.segmentFilteredData, ['type', 'employee_size']);
              if(userProfileIndex !== -1) {
                researchData.userProfileFilter.employee_size = _.sortBy(researchData.userProfileFilter.employee_size, ['sequence']);
                this.userProfileFilter[userProfileIndex].data = researchData.userProfileFilter.employee_size;
                let dataArray = [];
                _.forEach(researchData.userProfileFilter.employee_size, (segObj) => {
                  dataArray.push({
                      id: segObj.id,
                      label: segObj.label
                  });
                });
                this.segmentFilteredData[segmentIndex].data = dataArray;
              }
            }
            if(researchData.userProfileFilter.job_title) {
              let userProfileIndex = _.findIndex(this.userProfileFilter, ['type', 'job_title']); 
              let segmentIndex = _.findIndex(this.segmentFilteredData, ['type', 'job_title']);
              if(userProfileIndex !== -1) {
                researchData.userProfileFilter.job_title = _.sortBy(researchData.userProfileFilter.job_title, ['sequence']);
                this.userProfileFilter[userProfileIndex].data = researchData.userProfileFilter.job_title;
                let dataArray = [];
                _.forEach(researchData.userProfileFilter.job_title, (segObj) => {
                  dataArray.push({
                      id: segObj.id,
                      label: segObj.jobTitle
                  });
                });
                this.segmentFilteredData[segmentIndex].data = dataArray;
              }
            }
            if(researchData.userProfileFilter.global_revenue) {
              let userProfileIndex = _.findIndex(this.userProfileFilter, ['type', 'global_revenue']); 
              let segmentIndex = _.findIndex(this.segmentFilteredData, ['type', 'global_revenue']);
              if(userProfileIndex !== -1) {
                this.userProfileFilter[userProfileIndex].data = researchData.userProfileFilter.global_revenue;
                this.segmentFilteredData[segmentIndex].data = researchData.userProfileFilter.global_revenue;
              }  
            }
          }
          // filtering userprofilefilter containing datas only
          this.userProfileFilter = _.filter(this.userProfileFilter, obj => {
            return obj.data.length;
          })
          if (researchData.userProfileClusterFilter) {
            this.userProfileClusterFilter = researchData.userProfileClusterFilter;
            researchData.userProfileClusterFilter.forEach((clusterObj) => {
              // userProfileFilter is for display.
              this.userProfileFilter.push({
                index: (this.userProfileFilter.length + 1),
                title: clusterObj.label,
                type: `${clusterObj.type}_cluster`,
                data: clusterObj.clusterFilter,
                dataIds: [],
                checked: false,
                showItems: false
              });
              const finalKey = this.getFinalKeywordFromSegmentFilters(clusterObj.type);
              //variant: 'cluster'
              // segmentFilteredData is for checked & data value processing
              this.segmentFilteredData.push({
                index: (this.segmentFilteredData.length + 1),
                title: clusterObj.label,
                type: `${clusterObj.type}_cluster`,
                data: clusterObj.clusterFilter,
                dataIds: [],
                checked: false,
                finalKey: finalKey,
                dataName: []
              });
            });
          }
        }
        this.techDomainId = researchData.techDomainId;
        this.solutionFilter.techDomainId = this.techDomainId;
        this.getSolutionFilterList(this.solutionFilter);
        if (!this.researchData) {
          this.mixpanelEventLoggingService.dispatchEvent("research module", {
            "Tech Domain": researchData.domain ? researchData.domain.name : '',
            "Module Name": researchData ? researchData.title : ''
          });
        }
        this.researchData = researchData ? researchData : null;
        this.researchDataId = researchData ? researchData.id : null;
        this.rating = researchData.myRatings ? researchData.myRatings.rating : 0;

      });
  }

  getMarketDataCategories() {
    this.rolesSharedService.getMarketDataCategories(this.researchDataId).subscribe(
      (marketDataRes: any) => {
        this.marketDataCategory = marketDataRes["length"]
          ? marketDataRes
          : null;
        this.categoryId = marketDataRes["length"] ? marketDataRes[0].id : null;
        this.categoryStatusData = marketDataRes["length"] ? marketDataRes[0] : null;
        this.activeMainCategoryId = marketDataRes["length"] ? marketDataRes[0].id : null;
        this.getMarketDataSubCategories(null);
        this.categoryStatus.subscribe(currentQuiz => {
          if (currentQuiz != '') {
            this.categoryStatusData = currentQuiz;
            if (this.categoryStatusData) {
              this.marketData = [];
              this.dataLimit = 2;
              this.skipValue = 0;
              this.categoryId = this.categoryStatusData.id;
              this.getMarketDataSubCategories(this.categoryStatusData.id);
            } else {
              this.categoryId = marketDataRes["length"] ? marketDataRes[0].id : null;
              this.categoryStatusData = marketDataRes["length"] ? marketDataRes[0] : null;
              this.getMarketDataSubCategories(null);
            }
          } else {
            this.fetchMyGraph();
          }
        });
      },
      (error: any) => { },
      () => {
        this.checkSSTExist();
      }
    );
  }

  selectCategory(currentQuiz) {
    // this.categoryStatusData = currentQuiz;
    // if (this.categoryStatusData) {
    //   this.marketData = [];
    //   this.dataLimit = 2;
    //   this.skipValue = 0;
    //   this.categoryId = this.categoryStatusData.id;
    //   this.getMarketDataSubCategories(this.categoryStatusData.id);
    // }
  }

  setCategorySelectedState(categoryData: any) {
    this.activeMainCategoryId = categoryData.id;
    if (categoryData.id == 'my-graph') {
      this.activeMainCategoryId = categoryData.id;
      this.ngRedux.dispatch({ type: 'UPDATE_CATEGORY', category: '' });
    } else if (this.marketDataFilter.subCategoryId) {
      this.getMarketDataSubCategories(categoryData.id);
      this.ngRedux.dispatch({ type: 'UPDATE_CATEGORY', category: categoryData });
    } else {
      this.getMarketDataSubCategories(categoryData.id);
      this.ngRedux.dispatch({ type: 'UPDATE_CATEGORY', category: categoryData });
    }

  }

  getMarketDataSubCategories(categoryId) {
    this.categoryId = categoryId ? categoryId : this.categoryId;
    const filter: any = {};
    filter.researchDocumentId = this.researchDataId;
    filter.categoryId = this.categoryId;
    this.rolesSharedService.getMarketDataSubCategory(filter).subscribe(
      (marketDataSubCatRes: any) => {
        this.marketDataSubCategory = marketDataSubCatRes["length"]
          ? marketDataSubCatRes
          : null;
        this.subCategegoryId = marketDataSubCatRes["length"]
          ? marketDataSubCatRes[0].id
          : null;
        this.subCategegoryId = null;
        if (this.activeSubMarketId) {
          this.activeSubMarketId = null;
          this.resetScroll(null);
        } else {
          this.resetScroll(null);
          // this.getMarketData(null);
        }
      },
      error => {
      }
    );
  }

  getGraphMarketDataLink(marketDataId) {
    if (marketDataId) {
      this.rolesSharedService.getReportLink(marketDataId).subscribe(
        (linkData: any) => {
          return linkData;
        },
        error => {
          return false;
        }
      );
    } else {
      return false;
    }
  }

  getMarketDataPagination(subcategoryId) {
    subcategoryId ? (this.marketDataFilter.subCategoryId = subcategoryId) : null;
    this.marketDataFilter.researchDocumentId = this.researchDataId;
    this.marketDataFilter.categoryId = this.categoryId;
    const checkId = this.marketDataFullDetails.findIndex(q => q.categoryId == this.categoryId);
    this.marketDataFilter.limit = this.dataLimit;
    this.marketDataFilter.skip = this.skipValue;
    if (this.marketDataFilter.skip === this.skipValue) {
      this.marketDataSubscription = this.rolesSharedService.getMarketDat(this.marketDataFilter, this.finalAppliedMasterFilter).subscribe(
        (marketData: any) => {
          this.loaderService.display(false);// quickfix for loader issue
          this.cdRef.detectChanges();
          if (marketData) {
            _.forEach(marketData, (marketData) => {
              marketData['marketData'] = {
                alphabeticalSorting: marketData.alphabeticalSorting,
                marketData: marketData.marketData,
                bookmarkId: marketData.bookmarkId,
                authorUserId: marketData.authorUserId,
                bookmarked: marketData.bookmarked,
                category: marketData.category,
                categoryId: marketData.categoryId,
                choiceOrder: marketData.choiceOrder,
                choices: marketData.choices,
                comments: marketData.comments,
                content: marketData.content,
                createdAt: marketData.createdAt,
                customQuestionFilters: marketData.customQuestionFilters,
                customUserProfileFilters: marketData.customUserProfileFilters,
                description: marketData.description,
                graphType: marketData.graphType,
                graphTypeId: marketData.graphTypeId,
                hasSolutionFilter: marketData.hasSolutionFilter,
                id: marketData.marketDataId,
                isActive: marketData.isActive,
                isClustered: marketData.isClustered,
                isDualAxisQuestion: marketData.isDualAxisQuestion,
                isParentQuestionGraph: marketData.isParentQuestionGraph,
                labels: marketData.labels,
                liked: marketData.liked,
                likes: marketData.likes,
                methodOfOperation: marketData.methodOfOperation,
                numberOfResponse: marketData.numberOfResponse,
                questionType: marketData.questionType,
                ratings: marketData.ratings,
                requiredChoices: marketData.requiredChoices,
                scale: marketData.scale,
                sortingOrder: marketData.sortingOrder,
                subCategoryId: marketData.subCategoryId,
                timeline: marketData.timeline,
                title: marketData.title,
                updatedAt: marketData.updatedAt,
                userBenchmark: marketData.userBenchmark,
                userFilters: marketData.userFilters,
                userProfileDataChoices: marketData.userProfileDataChoices,
                viableCount: marketData.viableCount,
                solutionQuestionFilterConfiguration: marketData.solutionQuestionFilterConfiguration,
                xAxischoices: marketData.xAxischoices,
                matrixChoices : marketData.matrixChoices
              };
            });

            _.forEach(marketData, (obj) => {
              obj.marketData.customQuestionFilters = _.orderBy(obj.marketData.customQuestionFilters, ['order'], ['asc']);
            });
            _.forEach(marketData, (responseObj) => {
              responseObj.marketData.vendorFiltersNamesMapping = [];
              if (responseObj.marketData.solutionQuestionFilterConfiguration) {
                if (responseObj.marketData.solutionQuestionFilterConfiguration.length > 0) {
                  _.forEach(responseObj.marketData.solutionQuestionFilterConfiguration, (questionObj) => {
                    let questionSolutionMaping = _.find(responseObj.marketData.customQuestionFilters, { 'questionId': questionObj.questionId });
                    let questionSolutionMapingIndex = _.findIndex(responseObj.marketData.customQuestionFilters, { 'questionId': questionObj.questionId });

                    if (questionSolutionMaping) {
                      responseObj.marketData.vendorFiltersNamesMapping.push(questionSolutionMaping.label);
                      responseObj.marketData.customQuestionFilters[questionSolutionMapingIndex].checkedQuestionFilter = false;
                    }
                  });

                  responseObj.marketData.vendorFiltersNamesMapping = responseObj.marketData.vendorFiltersNamesMapping.join();
                }
              }
            });
            let matchedGeographyObject;
            // test start
            _.forEach(marketData, (responseObject) => {
              _.map(responseObject.marketData.userFilters.country, (countryObject) => {

                matchedGeographyObject = _.find(this.geographyCountryMaping, { 'countryId': countryObject.id });
                countryObject.geographyId = matchedGeographyObject.geographyId;
              });
            });
            this.getSolutionFilterList(this.solutionFilter);
            // to save solution filter (sub domain list) in user filters
            _.map(marketData, (marketObject) => {
              marketObject.marketData.userFilters.solutions = _.cloneDeep(this.solution)
            });
            if (marketData.length > 0) {
              const catId = this.categoryId;
              const respCatId = marketData[0].marketData.categoryId;
              if (respCatId === catId) {
                marketData.forEach((element, i) => {
                  const marketDataIndex = this.marketData.findIndex((obj) => obj.id === element.id);
                  if (marketDataIndex === -1) {
                    if (marketData[i].marketData.category && marketData[i].marketData.category.categoryName === "VendorScope") {
                      this.logInMixpanel(this.researchData.domain.name, marketData[i].marketData.title);
                    }
                    if (marketData[i].reportsAttached && marketData[i].reportsAttached > 0) {
                      element['reportsLinked'] = marketData[i].reportsAttached;

                      this.rolesSharedService.getReportLink(marketData[i].marketData.id).subscribe(
                        (linkData: any) => {
                          element['reportLinkData'] = linkData;
                        },
                      );
                    }
                    if (marketData[i].numberOfResponse < this.lowerParameter) {
                      marketData[i].marketData['setMessage'] = true;
                    }
                    if (marketData[i].numberOfResponse > 0 && marketData[i].numberOfResponse < this.lowerParameter) {
                      marketData[i].veryLowSampleSize = true;
                    }
                    else {
                      marketData[i].veryLowSampleSize = false;
                    }
                    if(this.appliedFilterList !== undefined && this.appliedFilterList.length > 0) {
                      marketData[i].marketData.appliedFilterList = this.appliedFilterList;
                    }
                    this.highChartSubscrition = this.marketDataChartGenerator
                      .generateChartJSON(marketData[i].marketData)
                      .subscribe((chartJSON: any) => {
                        marketData[i].ChartJSON = chartJSON;
                        this.ref.detectChanges();
                      });
                    element[`benchMarkModalStatus`] = false,
                      element[`benchMarkFilter`] = element.marketData.userBenchmark,
                      element[`selectedbenchMarkFilter`] = {
                        againstAll: false,
                        againstMyDomain: false,
                        myDomainVsAllDomain: false
                      };
                    this.marketData.push(element);
                    // this.backUpdata(i);
                    const item = {
                      categoryId: this.categoryId,
                      marketData: this.marketData
                    };
                    const indexOfItemInArray = this.marketDataFullDetails.findIndex(q => q.categoryId === item.categoryId);

                    if (indexOfItemInArray > -1) {
                      this.marketDataFullDetails[indexOfItemInArray] = item;
                    } else {
                      this.marketDataFullDetails.push(item);
                    }

                  }
                });
                this.marketData.forEach((element, mkIndex) => {
                  this.backUpdata(mkIndex);
                });
              } else {
                this.marketData = [];
                this.getMarketData(subcategoryId);
              }
            } else {
            }
          }
        },
        error => {
        }
      );
    }
  }
  getFilterEmpty(userFilters) {
    const result = this.utilityService.getFilterEmpty(userFilters);
    return result;
  }

  logInMixpanel(techDomain, graphTitle) {
    this.mixpanelEventLoggingService.dispatchEvent("vendorcscopes", {
      "Tech Domain": techDomain ? techDomain : '',
      "Graph Title": graphTitle ? graphTitle : ''
    });
  }

  getMarketData(subcategoryId) {
    subcategoryId ? (this.marketDataFilter.subCategoryId = subcategoryId) : null;
    this.marketDataFilter.researchDocumentId = this.researchDataId;
    this.marketDataFilter.categoryId = this.categoryId;
    let checkId;
    if (subcategoryId) {
      this.marketDataFilter.subCategoryId = subcategoryId;
      checkId = this.marketDataFullDetails.findIndex(q => q.categoryId == this.categoryId && q.subcategoryId == subcategoryId);
    } else {
      // force rendering need to improve the perfomance
      delete this.marketDataFilter['subCategoryId'];
      // checkId = this.marketDataFullDetails.findIndex(q => q.categoryId == this.categoryId);
      checkId = -1;
    }
    if (checkId > -1) {
      const marketDataDetat = this.marketDataFullDetails.filter(q => q.categoryId == this.marketDataFilter.categoryId);
      const marketData = marketDataDetat[0].marketData;
      this.skipValue = marketData.length;
      marketData.forEach((element, i) => {
        const marketDataIndex = this.marketData.findIndex((obj) => obj.id === element.id);
        if (marketDataIndex === -1) {
          const catId = this.categoryId;
          const respCatId = marketData[0].marketData.categoryId;
          if (respCatId === catId) {
            marketData.forEach((element, i) => {
              const marketDataIndex = this.marketData.findIndex((obj) => obj.id === element.id);
              if (marketDataIndex === -1) {
                if (marketData[i].reportsAttached && marketData[i].reportsAttached > 0) {
                  element['reportsLinked'] = marketData[i].reportsAttached;
                  //    element['reportLinkData'] = this.getGraphMarketDataLink(marketData[i].marketData.id);

                  this.rolesSharedService.getReportLink(marketData[i].marketData.id).subscribe(
                    (linkData: any) => {
                      element['reportLinkData'] = linkData;
                    },
                  );
                }
                if (marketData[i].numberOfResponse < this.lowerParameter) {
                  marketData[i].marketData['setMessage'] = true;
                }
                if (marketData[i].numberOfResponse > 0 && marketData[i].numberOfResponse < this.lowerParameter) {
                  marketData[i].veryLowSampleSize = true;
                }
                else {
                  marketData[i].veryLowSampleSize = false;
                }
                if(this.appliedFilterList !== undefined && this.appliedFilterList.length > 0) {
                  marketData[i].marketData.appliedFilterList = this.appliedFilterList;
                }
                this.highChartSubscrition = this.marketDataChartGenerator
                  .generateChartJSON(marketData[i].marketData)
                  .subscribe((chartJSON: any) => {
                    marketData[i].ChartJSON = chartJSON;
                    //  this.ref.detectChanges();
                  });
                element[`benchMarkModalStatus`] = false,
                  element[`benchMarkFilter`] = element.marketData.userBenchmark,
                  element[`selectedbenchMarkFilter`] = {
                    againstAll: false,
                    againstMyDomain: false,
                    myDomainVsAllDomain: false
                  };
                this.marketData.push(element);
                  // this.backUpdata(i);
              }
            });
            this.marketData.forEach((element, mkIndex) => {
              this.backUpdata(mkIndex);
            });
          } else {
            this.marketData = [];
            this.getMarketData(subcategoryId);
          }
        }
      });
    } else {
      this.marketDataFilter.limit = this.dataLimit;
      this.marketDataFilter.skip = this.skipValue;
      // this.marketDataFilter.masterFilter = this.finalAppliedMasterFilter;
      if (this.marketDataFilter.skip === this.skipValue) {
        this.marketDataSubscription = this.rolesSharedService.getMarketDat(this.marketDataFilter, this.finalAppliedMasterFilter).subscribe(
          (marketData: any) => {
            this.loaderService.display(false); // quickfix for loader issue
            this.cdRef.detectChanges();
            if(marketData) {
            _.forEach(marketData, (marketData) => {
              marketData['marketData'] = {
                alphabeticalSorting: marketData.alphabeticalSorting,
                marketData: marketData.marketData,
                bookmarkId : marketData.bookmarkId,
                authorUserId : marketData.authorUserId,
                bookmarked : marketData.bookmarked,
                category : marketData.category,
                categoryId : marketData.categoryId,
                choiceOrder : marketData.choiceOrder,
                choices : marketData.choices,
                comments : marketData.comments,
                content : marketData.content,
                createdAt : marketData.createdAt,
                customQuestionFilters : marketData.customQuestionFilters,
                customUserProfileFilters : marketData.customUserProfileFilters,
                description : marketData.description,
                graphType : marketData.graphType,
                graphTypeId : marketData.graphTypeId,
                hasSolutionFilter : marketData.hasSolutionFilter,
                id : marketData.marketDataId,
                isActive : marketData.isActive,
                isClustered : marketData.isClustered,
                isDualAxisQuestion: marketData.isDualAxisQuestion,
                isParentQuestionGraph : marketData.isParentQuestionGraph,
                labels : marketData.labels,
                liked : marketData.liked,
                likes : marketData.likes,
                methodOfOperation : marketData.methodOfOperation,
                numberOfResponse : marketData.numberOfResponse,
                questionType : marketData.questionType,
                ratings : marketData.ratings,
                requiredChoices : marketData.requiredChoices,
                scale : marketData.scale,
                sortingOrder : marketData.sortingOrder,
                subCategoryId : marketData.subCategoryId,
                timeline : marketData.timeline,
                title : marketData.title,
                updatedAt : marketData.updatedAt,
                userBenchmark : marketData.userBenchmark,
                userFilters : marketData.userFilters,
                userProfileDataChoices : marketData.userProfileDataChoices,
                viableCount : marketData.viableCount,
                solutionQuestionFilterConfiguration: marketData.solutionQuestionFilterConfiguration,
                xAxischoices: marketData.xAxischoices,
                matrixChoices : marketData.matrixChoices
                //
              };
            });
            if(marketData && marketData[0] && marketData[0].marketData) {
              marketData[0].marketData.customQuestionFilters = _.orderBy(marketData[0].marketData.customQuestionFilters, ['order'], ['asc']);
            }
            _.forEach(marketData, (responseObject) => {
              responseObject.marketData.customQuestionFilters = _.orderBy(responseObject.marketData.customQuestionFilters, ['order'], ['asc']);
             });
            _.forEach(marketData, (responseObject) => {
             this.isParent = responseObject.marketData.isParentQuestionGraph? responseObject.marketData.isParentQuestionGraph : false;
            });
            _.forEach(marketData, (responseObj)=> {
              responseObj.marketData.vendorFiltersNamesMapping = [];
              if(responseObj.marketData.solutionQuestionFilterConfiguration) {
                if(responseObj.marketData.solutionQuestionFilterConfiguration.length > 0) {
                _.forEach(responseObj.marketData.solutionQuestionFilterConfiguration, (questionObj) => {
                  let questionSolutionMaping = _.find(responseObj.marketData.customQuestionFilters, {'questionId': questionObj.questionId});
                  let questionSolutionMapingIndex = _.findIndex(responseObj.marketData.customQuestionFilters, {'questionId': questionObj.questionId});

                      if (questionSolutionMaping) {
                        responseObj.marketData.vendorFiltersNamesMapping.push(questionSolutionMaping.label);
                        responseObj.marketData.customQuestionFilters[questionSolutionMapingIndex].checkedQuestionFilter = false;
                      }
                    });

                    responseObj.marketData.vendorFiltersNamesMapping = responseObj.marketData.vendorFiltersNamesMapping.join();
                  }
                }
              });
              let matchedGeographyObject;
              // test start
              _.forEach(marketData, (responseObject) => {
                _.map(responseObject.marketData.userFilters.country, (countryObject) => {

                  matchedGeographyObject = _.find(this.geographyCountryMaping, { 'countryId': countryObject.id });
                  countryObject.geographyId = matchedGeographyObject.geographyId;
                });
              });
              //test end
              this.getSolutionFilterList(this.solutionFilter);
              // to save solution filter (sub domain list) in user filters
              _.map(marketData, (marketObject) => {
                marketObject.marketData.userFilters.solutions = _.cloneDeep(this.solution);
              });
              if (marketData.length > 0) {
                const catId = this.categoryId;
                const respCatId = marketData[0].marketData.categoryId;
                if (respCatId === catId) {
                  marketData.forEach((element, i) => {
                    const marketDataIndex = this.marketData.findIndex((obj) => obj.id === element.id);
                    if (marketDataIndex === -1) {
                      if (marketData[i].marketData.category && marketData[i].marketData.category.categoryName === "VendorScope") {
                        this.logInMixpanel(this.researchData.domain.name, marketData[i].marketData.title);
                      }
                      if (marketData[i].reportsAttached && marketData[i].reportsAttached > 0) {
                        element['reportsLinked'] = marketData[i].reportsAttached;
                        // element['reportLinkData'] = this.getGraphMarketDataLink(marketData[i].marketData.id);

                        this.rolesSharedService.getReportLink(marketData[i].marketData.id).subscribe(
                          (linkData: any) => {
                            element['reportLinkData'] = linkData;
                          },
                        );
                      }
                      if (marketData[i].numberOfResponse < this.lowerParameter) {
                        marketData[i].marketData['setMessage'] = true;
                      }
                      if (marketData[i].numberOfResponse > 0 && marketData[i].numberOfResponse < this.lowerParameter) {
                        marketData[i].veryLowSampleSize = true
                      }
                      else {
                        marketData[i].veryLowSampleSize = false;
                      }
                      if(this.appliedFilterList !== undefined && this.appliedFilterList.length > 0) {
                        marketData[i].marketData.appliedFilterList = this.appliedFilterList;
                      }
                      this.highChartSubscrition = this.marketDataChartGenerator
                        .generateChartJSON(marketData[i].marketData)
                        .subscribe((chartJSON: any) => {
                          marketData[i].ChartJSON = chartJSON;
                          //   this.ref.detectChanges();
                        });
                      element[`benchMarkModalStatus`] = false,
                        element[`benchMarkFilter`] = element.marketData.userBenchmark,
                        element[`selectedbenchMarkFilter`] = {
                          againstAll: false,
                          againstMyDomain: false,
                          myDomainVsAllDomain: false
                        };
                      this.marketData.push(element);
                      // this.backUpdata(i);
                      const item = {
                        categoryId: this.categoryId,
                        marketData: this.marketData
                      };
                      const indexOfItemInArray = this.marketDataFullDetails.findIndex(q => q.categoryId === item.categoryId);

                      if (indexOfItemInArray > -1) {
                        this.marketDataFullDetails[indexOfItemInArray] = item;
                      } else {
                        this.marketDataFullDetails.push(item);
                      }

                    }
                  });
                  this.marketData.forEach((element, mkIndex) => {
                    this.backUpdata(mkIndex);
                  });
                } else {
                  this.marketData = [];
                  this.getMarketData(subcategoryId);
                }
              } else {
              }
            }
          },
          error => {
          }
        );
      }
    }
  }
  resetMarketData() {

  }


  onScrollDown() {
    this.scrollSet = true;
    // Todo adding quick fix for qa demo
    const isPrimeCall = sessionStorage.getItem('isPrimeCall');
    if (isPrimeCall) {
      this.skipValue = 0;
      sessionStorage.removeItem('isPrimeCall');
    } else {
      this.skipValue = this.skipValue + 2;
    }
    this.getMarketDataPagination(this.marketDataSubCatId);
  }

  resetScroll(id) {
    this.dataLimit = 2;
    this.skipValue = 0;
    this.marketDataSubCatId = id;
    this.marketData = [];
    this.getMarketData(id);
  }
  redarwGraph(id) {
    this.getMarketData(this.marketDataSubCatId);
  }

  likeClick(postData: any, type: string) {
    // like button click
    if (this.loggedInStatus) {
      if (this.userDetailsObject.nickName) {
        const dataBody = {
          postId: postData.id,
          postType: type,
          userId: this.userId
        };
        this.rolesSharedService.addLike(dataBody).subscribe(likeResponse => {
          if (likeResponse["liked"]) {
            // case when user is liked and updated in server
            postData.liked = true;
            postData.likes += 1;
            this.rolesSharedService.logLikeInMixpanel(dataBody.postType, postData.title);
          } else if (!likeResponse["liked"]) {
            // case when user is not liked and updated in server
            postData.liked = false;
            if (postData.likes != 0) {
              postData.likes -= 1;
            }
          }
        });
      } else {
        this.nickNameModalService.openNickNameModal();
        this.nickNameModalService.nickNameDataUpdatedObservable.subscribe(
          (response: any) => {
            if (response) {
              this.userDetails();
            }
          }
        );
      }
    } else {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  bookmark(data: any, type: string) {
    const bookmarkData: any = {};
    if (data.bookmarkId && data.bookmarked) {
      bookmarkData.bookmarkId = data.bookmarkId;
    }
    if (data.bookmarkId === undefined) {
      let bookmarkedIndex = _.findIndex(this.marketData, (obj) => {
        return obj.marketData && obj.marketData.id === data.id;
      });
      bookmarkData.bookmarkId = this.marketData[bookmarkedIndex].marketData.bookmarkId;
    }
    if (type == "researchDocument") {
      bookmarkData.postId = data.id;
      bookmarkData.postType = type;
    } else {
      bookmarkData.postId = data.id;
      bookmarkData.postType = type;
      bookmarkData.researchDocumentId = this.researchDataId;
      bookmarkData.marketDataFilter = data.content;
    }
    this.rolesSharedService.bookmark(bookmarkData).subscribe(
      (response: any) => {
        let bookmarkedIndex = _.findIndex(this.marketData, (obj) => {
          return obj.marketData && obj.marketData.id === data.id;
        });
        this.marketData[bookmarkedIndex].marketData.bookmarkId = response.bookmarkId;
        this.getResearchData(this.researchDataId);
        if (response.bookmarked) {
          if (type == "researchDocument") {
            this.researchData.bookmarked = true;
            this.mixpanelEventLoggingService.dispatchEvent("bookmark module", {
              "Tech Domain": this.researchData.domain ? this.researchData.domain.name : '',
              "Module Name": this.researchData ? this.researchData.title : ''
            });
          } else if (type == "marketData") {
            data.bookmarked = true;
            this.mixpanelEventLoggingService.dispatchEvent("bookmark market data", {
              "Tech Domain": this.researchData.domain ? this.researchData.domain.name : '',
              "Market Data Title": data.title ? data.title : ''
            });
          }
          swal({
            position: "center",
            type: "success",
            title: "Added to the bookmarks list",
            showConfirmButton: false,
            timer: 1000
            // text: "Bookmarked"
          });
        } else {
          if (type == "research_document") {
            this.researchData.bookmarked = false;
          } else if (type == "market_data") {
            data.bookmarked = false;
          }
          swal({
            position: "center",
            type: "success",
            title: "Removed from the bookmarks list",
            showConfirmButton: false,
            timer: 1000
            // text: "Bookmarked"
          });
        }
      },
      error => { }
    );
  }

  ratingButtonClick(researchData: string, postType: string) { }

  routeMarketDataDetails(marketData: any) {
    marketData.researchDataId = this.researchDataId;
    this.marketDataDetailsService.marketData(marketData);
    this.router.navigate([`${this.userRole}/market-data-details/${this.researchDataId}/${marketData.id}`]);
  }

  mapPostData(researchData: any) {
    let data: any = {};
    if (researchData.myRatings) {
      data = {
        id: researchData.myRatings.id,
        postId: researchData.id,
        rating: this.rating,
        userId: this.userId,
        postType: "research_document"
      };
    } else {
      data = {
        postId: researchData.id,
        rating: this.rating,
        userId: this.userId,
        postType: "research_document"
      };
    }
    return data;
  }

  trigerRatingOutput(researchData: any) {
    if (researchData.myRatings) {
      this.rolesSharedService
        .rating(JSON.stringify(this.mapPostData(researchData)))
        .subscribe((response: any) => {
          if (response) {
            researchData.myRatings = true;
            this.closeRatingModal();
            this.getResearchData(this.researchDataId);
          }
        });
    } else {
      this.rolesSharedService
        .submitRating(JSON.stringify(this.mapPostData(researchData)))
        .subscribe((response: any) => {
          if (response) {
            researchData.myRatings = true;
            this.closeRatingModal();
            this.getResearchData(this.researchDataId);
          }
        });
    }
  } 

  closeRatingModal() {
    this.rating = 0;
    $("#ratingModal").modal("hide");
  }

  openCommentModal(data, postType?) {
    let post: any;
    if (postType === 'market_data') {
      post = data.marketData;
      post.researchDocumentId = data.researchDocumentId;
    } else {
      post = data;
    }
    post.postType = postType;
    if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
    }
    if (this.loggedInStatus && this.userDetailsObject != undefined && this.userDetailsObject.nickName) {
      this.commentModalService.modalStatus(true, post);
    } else {
      this.nickNameModalService.openNickNameModal();
    }
  }

  populateComments(data, postType?) {
    let post: any;
    if (postType === 'market_data') {
      post = data.marketData;
      post.researchDocumentId = data.researchDocumentId;
    } else {
      post = data;
    }
    post.postType = postType;
    if (this.userDetailsObject.nickName) {
      data.showComments = !data.showComments;
    } else {
      this.nickNameModalService.openNickNameModal();
      this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
        if (response) {
          this.userDetails();
        }
      });
    }
  }

  accessSubCat(id) {
    if (this.activeSubMarketId === id) {
      this.activeSubMarketId = null;
      this.resetScroll(null);
    } else {
      this.activeSubMarketId = id;
      this.resetScroll(id);
    }
  }

  checkSSTExist() {
    this.sstService.checkSSTExist(this.researchDataId)
      .subscribe(isExist => {
        if (isExist['exists']) {
          this.marketDataCategory.push({ id: 'my-graph', categoryName: 'My Graph' });
          if (!this.categoryStatusData) {
            this.fetchMyGraph();
          }
        }
      });
  }

  createMyGraph() {
    this.router.navigate([`${this.userRole}/self-service/${this.researchDataId}`]);
  }

  fetchMyGraph() {
    this.sstGraphMarketData = [];
    this.skipValue = 0;
    const data = {
      docId: this.researchDataId,
      limit: this.dataLimit,
      skip: this.skipValue
    };
    this.sstService.getSSTGraphData(data).subscribe(resp => {
      this.sstMarketData = resp['data'];
      this.sstGraphMarketData = [];
      this.sstMarketData.forEach((element, i) => {
        const marketDataIndex = this.sstMarketData.findIndex((obj) => obj.id === element.id);

        this.highChartSubscrition = this.marketDataChartGenerator
          .generateChartJSON(this.sstMarketData[i])
          .subscribe((chartJSON: any) => {
            this.sstMarketData[i].ChartJSON = chartJSON;
            // this.ref.detectChanges();
          });
        this.sstGraphMarketData.push(element);
      });
    });
  }

  onScrollDownSST() {
    this.scrollSet = true;
    const isPrimeCall = sessionStorage.getItem('isPrimeCall');
    if (isPrimeCall) {
      this.skipValue = 0;
      sessionStorage.removeItem('isPrimeCall');
    } else {
      this.skipValue = this.skipValue + 2;
    }
    this.fetchMyGraphPagination();
  }

  fetchMyGraphPagination() {
    const data = {
      docId: this.researchDataId,
      limit: this.dataLimit,
      skip: this.skipValue
    };
    this.sstService.getSSTGraphData(data).subscribe(resp => {
      if (resp['data'] && resp['data'].length > 0) {
        this.sstMarketData = resp['data'];
        this.sstMarketData.forEach((element, i) => {
          const marketDataIndex = this.sstMarketData.findIndex((obj) => obj.id === element.id);

          this.highChartSubscrition = this.marketDataChartGenerator
            .generateChartJSON(this.sstMarketData[i])
            .subscribe((chartJSON: any) => {
              this.sstMarketData[i].ChartJSON = chartJSON;
              // this.ref.detectChanges();
            });
          this.sstGraphMarketData.push(element);
        });
      }
    });
  }


  openLikeModal(data, postType?) {
    if (this.loggedInStatus) {
      this.likeModalService.modalStatus(true, data);
    }
  }

  setStatusBenchmarkModal(status: boolean, data?: any, index?: any) {
    if (status == true) {
      this.currentBenchmarkFilterIndex = index;
      this.marketData[index].benchMarkModalStatus = true;
    } else if (status == false) {
      this.currentBenchmarkFilterIndex = index;
      this.marketData[index].benchMarkModalStatus = false;
    }
  }

  resetBenchMarkFilters(index) {
    this.marketData[index].selectedbenchMarkFilter.againstAll = this.marketData[index].benchMarkFilter.againstAll;
    this.marketData[index].selectedbenchMarkFilter.myChoiceVsMarket = this.marketData[index].benchMarkFilter.myChoiceVsMarket;
    this.marketData[index].selectedbenchMarkFilter.isNumericBenchMark = this.marketData[index].benchMarkFilter.isNumericBenchMark;
    this.marketData[index].selectedbenchMarkFilter.realBenchmark = this.marketData[index].benchMarkFilter.realBenchmark;
    this.marketData[index].selectedbenchMarkFilter.myChoiceVsMarket = false;
    this.marketData[index].selectedbenchMarkFilter.myChoiceVsMyOrg = false;
    this.marketData[index].selectedbenchMarkFilter.myOrgVsMarket = false;
  }

  becnchMarkChanges(benchMarkClick: any, index) {
    this.currentBenchmarkFilterIndex = index;
    this.marketData[index].selectedbenchMarkFilter.againstAll = true;
    this.marketData[index].selectedbenchMarkFilter.isNumericBenchMark = true;
    this.marketData[index].selectedbenchMarkFilter.realBenchmark = true;
    if (benchMarkClick == 'myChoiceVsMarket') {
      this.marketData[index].selectedbenchMarkFilter.myChoiceVsMarket = true;
      this.marketData[index].selectedbenchMarkFilter.myChoiceVsMyOrg = false;
      this.marketData[index].selectedbenchMarkFilter.myOrgVsMarket = false;
    } else if (benchMarkClick == 'myChoiceVsMyOrg') {
      this.marketData[index].selectedbenchMarkFilter.myChoiceVsMarket = false;
      this.marketData[index].selectedbenchMarkFilter.myChoiceVsMyOrg = true;
      this.marketData[index].selectedbenchMarkFilter.myOrgVsMarket = false;
    } else if (benchMarkClick == 'myOrgVsMarket') {
      this.marketData[index].selectedbenchMarkFilter.myChoiceVsMarket = false;
      this.marketData[index].selectedbenchMarkFilter.myChoiceVsMyOrg = false;
      this.marketData[index].selectedbenchMarkFilter.myOrgVsMarket = true;
    } else if (!benchMarkClick) {
      this.marketData[index].selectedbenchMarkFilter.myChoiceVsMarket = false;
      this.marketData[index].selectedbenchMarkFilter.myChoiceVsMyOrg = false;
      this.marketData[index].selectedbenchMarkFilter.myOrgVsMarket = false;
    }
    this.saveBenchMarkFilter();
  }
  saveBenchMarkFilter() {
    this.filterApply(this.currentBenchmarkFilterIndex);
  }

  isNotEmptyObject(object) {
    return (_.isEmpty(object) ? false : true);
  }
  selectedBechmarkType(type, i) {
    if (this.marketData[i].benchMarkModalStatus && type) {
      this.marketData[i].benchMarkModalStatus = false;
    }
    this.becnchMarkChanges(type, i);
  }

  setStatusTimeLineAnalysisModal(status: boolean, id?: any) {
    if (status == true) {
      this.currentTimeLineFilterIndex = id;
      $('#timeLineAnalysisModal').modal('show');
      this.timeLineAnalysisModalStatus = true;
    } else if (status == false) {
      this.currentTimeLineFilterIndex = id;
      $('#timeLineAnalysisModal').modal('hide');
      this.timeLineAnalysisModalStatus = false;
    }
  }

  resetTimeLineAnalysisChanges() {
    this.timeLineAnalysisFilter.startDate = null;
    this.timeLineAnalysisFilter.endDate = null;
    this.filterApply(this.currentTimeLineFilterIndex);
    $('#timeLineAnalysisModal').modal('hide');
    this.timeLineAnalysisModalStatus = false;
  }

  saveTimeLineAnalysisFilter() {
    if (this.timeAnalysisStartDate < this.timeAnalysisEndDate) {
      this.timeLineAnalysisFilter.startDate = this.timeAnalysisStartDate;
      this.timeLineAnalysisFilter.endDate = this.timeAnalysisEndDate;
      this.filterApply(this.currentTimeLineFilterIndex);
      $('#timeLineAnalysisModal').modal('hide');
      this.timeLineAnalysisModalStatus = false;
    } else {
      swal({
        position: "center",
        type: "info",
        title: "Please choose a valid date range",
        showConfirmButton: false,
        timer: 2000
      });
    }
  }

  setProfileCusterData(choiceData: any[], j, type) {
    if (type === 'industry') {
      this.marketData[j].marketData.userFilteredData['industryId'] = [];
      this.marketData[j].marketData.userFilteredData['industryId'] = [...this.marketData[j].marketData.userFilteredData['industryId'], ...choiceData];
    } else if (type === 'country') {
      this.marketData[j].marketData.userFilteredData['countryId'] = [];
      this.marketData[j].marketData.userFilteredData['countryId'] = choiceData;
    } else if (type === 'employee_size') {
      this.marketData[j].marketData.userFilteredData['employeeSizeId'] = [];
      this.marketData[j].marketData.userFilteredData['employeeSizeId'] = choiceData;
    } else if (type === 'job_title') {
      this.marketData[j].marketData.userFilteredData['jobTitleId'] = [];
      this.marketData[j].marketData.userFilteredData['jobTitleId'] = choiceData;
    } else if (type === 'revenue') {
      this.marketData[j].marketData.userFilteredData['globalRevenueId'] = [];
      this.marketData[j].marketData.userFilteredData['globalRevenueId'] = choiceData;
    } else if (type === 'it_budget') {
      this.marketData[j].marketData.userFilteredData['itBudgetId'] = [];
      this.marketData[j].marketData.userFilteredData['itBudgetId'] = choiceData;
    } else if (type === 'line_of_business') {
      this.marketData[j].marketData.userFilteredData['lineOfBusinessId'] = [];
      this.marketData[j].marketData.userFilteredData['lineOfBusinessId'] = choiceData;
    } else if (type === 'geography') {
      this.marketData[j].marketData.userFilteredData['geographyId'] = [];
      this.marketData[j].marketData.userFilteredData['geographyId'] = choiceData;
    } else if (type === 'solutions') {
      this.marketData[j].marketData.userFilteredData['subTechDomainId'] = [];
      this.marketData[j].marketData.userFilteredData['subTechDomainId'] = choiceData;
    }
  }
  getSolutionFilterList(solutionFilter) {
    this.rolesSharedService.getSolutionFilter(solutionFilter).subscribe((response) => {
      _.map(response['data'], (dataObj) => {
        dataObj.status = false;
      });
      this.solution = response['data'];
    });
  }
  getUserRole() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.vendorRole = this.userDetailsObject.roles[0].code;
    }
    if (this.vendorRole == 'tech_vendor' || this.vendorRole == 'tech_analyst' || this.vendorRole == 'ecosystm_staff') {
      this.roleStatus = true;
    }
  }

  download(data: any) {
    const url = data.excelSheetUrl;
    const moduleName = data.title;
    return this.http.get(url, {
      responseType: ResponseContentType.Blob
    })
      .map(res => {
        return {
          filename: `${moduleName}.xlsx`,
          data:  new Blob([res.blob()],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
         // data: res.blob()
        };
      })
      .subscribe(res => {
        const link = window.URL.createObjectURL(res.data);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = link;
        a.download = res.filename;
        a.click();
        window.URL.revokeObjectURL(link);
        a.remove(); // remove the element
      }, error => {
         console.log('error', error);
      }, () => {

      });
  }
  setFilteredData(segmentDatas, event) {
    if(event.itemValue.checked === true) {
      this.isSegmentChecked = false;
    }
    else {
      this.isSegmentChecked = true;
    }
    this.selectedIndex = _.findIndex(this.segmentFilteredData, ['type', `${event.itemValue.type}`]);
    if (segmentDatas && segmentDatas.length === 0) {
      this.disableOptions = true;
    } else {
      this.disableOptions = false;
    }
    let userProfileSegmentIndex = _.findIndex(this.userProfileFilter, ['type', `${event.itemValue.type}`]);  
    if (userProfileSegmentIndex !== -1) {
      // important.
      this.userProfileFilter[userProfileSegmentIndex].checked = this.isSegmentChecked;
    }
    if (this.isSegmentChecked === true) {
      // checked true
      if (this.selectedIndex !== -1) {
        this.segmentFilteredData[this.selectedIndex].checked = true;
      }
    } else {
      // uncheck case, event.itemValue contain the unchecked object.
      if (this.selectedIndex !== -1) {
        this.segmentFilteredData[this.selectedIndex].checked = false;
        _.forEach(this.segmentFilteredData[this.selectedIndex].data, (dataObj) => {
          dataObj.checked = false;
          let index = _.findIndex(this.selectedData, dataObj);
          if (index !==-1) {
            this.selectedData.splice(index, 1);
          }
        });
        this.segmentFilteredData[this.selectedIndex].dataIds = [];
      }
      // for setting up next selected category for options listing.
      this.selectedIndex = _.findIndex(this.segmentFilteredData, ['checked', true]); 
      this.updateMasterAppliedFilters();
    }
  }
  resetMasterFilter() {
    this.isApplyTrue = false;
    this.skipValue = 0;
    this.dataLimit = 2;
    this.disableOptions = true;
    this.hasAppliedFilters = false;
    this.resetActive = false;
    this.finalAppliedMasterFilter ={};
    this.marketData = [];
    this.isSegmentChecked = false;
    this.appliedFilterList = []
    this.selectedSegment = undefined;
    this.selectedData = undefined;
    _.forEach(this.segmentFilteredData, (segObj) => {
      segObj.checked = false;
      _.forEach(segObj.data, (dataObj) => {
        dataObj.checked = false;
      });
      // segObj.data = [];
      // segObj.dataIds = [];
    });
    _.forEach(this.userProfileFilter, (obj) => {
      obj.checked = false;
      _.forEach(obj.data, (dataObj) => {
        dataObj.checked = false;
      });
    });
    // this.appliedFilterList = [];
    this.getMarketData(this.subCategegoryId);
  }
  setMessage() {
    if (this.disableOptions === true) {
      Toastr({
        type: "warning",
        text: "Please select atleast one segment"
      });
    }
  }
  setAppliedFilters(selectedData, index, event) {
    let filterIndex;
    if (event.value.length !== 0) {
      this.hasAppliedFilters = true;
      _.forEach(this.segmentFilteredData[index].data , (segObg) => {
        filterIndex = _.findIndex(selectedData, segObg);    
        if (filterIndex !== -1) {
          segObg.checked = true;
        }
        else {
          segObg.checked = false;
        }

      });
      this.isApplyTrue = true;
      this.updateMasterAppliedFilters();
    }
    else {
      this.hasAppliedFilters = false;
      this.appliedFilterList = [];
      this.isApplyTrue = false;
      // this.updateMasterAppliedFilters();
    }

  }

  filterClose(value, index) {
    let type;
    let filterIndex;
    type = this.appliedFilterList[index].type;
    filterIndex = _.findIndex(this.segmentFilteredData, ['type', type]);
    let dataId  = _.findIndex(this.segmentFilteredData[filterIndex].data, ['label', value]);
    this.segmentFilteredData[filterIndex].data[dataId].checked = false;
    let selectedItems = _.filter(this.segmentFilteredData[filterIndex].data, {'checked': true});
    if (selectedItems.length === 0) {
      this.segmentFilteredData[filterIndex].checked = false;
      let uIndex = _.findIndex(this.userProfileFilter,  ['type', this.segmentFilteredData[filterIndex].type])
      let dataSegment = this.userProfileFilter[uIndex];
      if (uIndex !== -1) {
        this.userProfileFilter[uIndex].checked = false;
      }
      let index = _.findIndex(this.selectedSegment, dataSegment);
      if (index !==-1) {
        this.selectedSegment.splice(index, 1);
      }
      this.selectedIndex = _.findIndex(this.segmentFilteredData, ['checked', true]); 
      if (this.selectedIndex === -1) {
        this.disableOptions = true;
      }
    }
    this.updateMasterAppliedFilters();
    let selectedDataArray = [];
    _.forEach(this.segmentFilteredData, (sObj) => {
      let checkedTrueItems = _.filter(sObj.data, {'checked': true});
      selectedDataArray.push(...checkedTrueItems);
    });
    this.selectedData = selectedDataArray;
    this.applyMasterFilter();
  }
  applyMasterFilter() {
    this.resetActive = true;
    let selectedFilters = _.filter(this.segmentFilteredData, {'checked' : true});
    _.forEach(selectedFilters, (filterObj) => {
      filterObj.dataIds = _.filter(filterObj.data, {'checked' : true});
      filterObj.dataIds = _.map(filterObj.dataIds, _.partialRight(_.pick, ['id']));
    });
    // this.finalAppliedMasterFilter = this.segmentFilteredData;
    // this.finalAppliedMasterFilter = _.map(this.finalAppliedMasterFilter, _.partialRight(_.pick, ['type','dataIds']));
    let finalMasterFilterIdObj = {
      industryId: [],
      itBudgetId: [],
      geographyId: [],
      lineOfBusinessId: [],
      countryId: [],
      employeeSizeId: [],
      jobTitleId: [],
      globalRevenueId: []
    }
    _.forEach(selectedFilters, (obj) => {
      if (/_cluster$/.test(obj.type)) {
        // for cluster types, exact dataIds will be in selected cluster's dataIds.
        const selectedData = _.filter(obj.data, {'checked' : true});
        _.forEach(selectedData, (clusterObj) => {
          let dataIds = clusterObj.dataIds;
          finalMasterFilterIdObj[`${obj.finalKey}`].push(...dataIds);
        });
      } else {
        let dataIds = obj.dataIds.map(el => el.id);
        finalMasterFilterIdObj[`${obj.finalKey}`].push(...dataIds);
      }
    });
    this.finalAppliedMasterFilter = finalMasterFilterIdObj;
    if (this.appliedFilterList.length === 0) {
      this.isApplyTrue = false;
      this.resetActive = false;
    }
    this.marketData = [];
    this.skipValue = 0;
    this.dataLimit = 2;
    this.getMarketData(this.subCategegoryId);
  }

  getFinalKeywordFromSegmentFilters(type) {
    let data = _.find(this.segmentFilteredData, {'type': type});
    return data ? data.finalKey : null;
  }
  updateMasterAppliedFilters() {
    if (this.appliedFilterList !== undefined || this.appliedFilterList !== null) {
      this.appliedFilterList = _.cloneDeep(this.segmentFilteredData)
      this.appliedFilterList = _.filter(this.appliedFilterList, {'checked' : true});
      _.forEach(this.appliedFilterList , (filData) => {
        filData.data = _.filter(filData.data, {'checked' : true});
        _.forEach(filData.data, (txtObj) => {
          filData.dataName.push(txtObj.label)
        })
      });
    }
  }
  searchFilters(text, type, marketDataIndex, index?) {
    // index is for some looping types like customQuestionFilters and customUserProfileFilters.
    let regexString = ".*"+ text + ".*";
    let searchRegex = new RegExp(regexString, 'i');
    this.backUpdata(marketDataIndex);
    switch (type) {
      case 'solutions':
        this.marketData[marketDataIndex].marketData.userFilters.solutions.noSearchResults = false;
        if (text !== '') {
          let searchResult = [];
          _.forEach(this.marketData[marketDataIndex].marketData.userFiltersBackup.solutions, (obj) => {
            if(searchRegex.test(obj.subDomainName)) {
              searchResult.push(obj);
            }
          });
          if (searchResult.length > 0) {
            this.marketData[marketDataIndex].marketData.userFilters.solutions = searchResult;
          }
          else {
            this.marketData[marketDataIndex].marketData.userFilters.solutions.noSearchResults  = true;
          }
        } else {
          this.marketData[marketDataIndex].marketData.userFilters.solutions =
            this.marketData[marketDataIndex].marketData['userFiltersBackup'].solutions;
        }
        this.marketData[marketDataIndex].marketData.userFilters.solutions.searchString = text;
        break;
      case 'customUserProfileFilters':
        this.marketData[marketDataIndex].marketData.customUserProfileFilters[index].noSearchResults = false;
        if (text !== '') {
          let searchResult = [];
          _.forEach(this.marketData[marketDataIndex].marketData.customUserProfileFiltersBackup[index].profileData, (obj) => {
            if(searchRegex.test(obj.text)) {
              searchResult.push(obj);
            }
          });
          if (searchResult.length > 0) {
            this.marketData[marketDataIndex].marketData.customUserProfileFilters[index].profileData = searchResult;
          }
          else {
            this.marketData[marketDataIndex].marketData.customUserProfileFilters[index].noSearchResults = true;
          }
        } else {
          this.marketData[marketDataIndex].marketData.customUserProfileFilters[index].profileData =
          this.marketData[marketDataIndex].marketData.customUserProfileFiltersBackup[index].profileData;
        }
        this.marketData[marketDataIndex].marketData.customUserProfileFilters[index].searchString = text;
        break;
      case 'geography':
        this.marketData[marketDataIndex].marketData.userFilters.geography.noSearchResults = false;
        if (text !== '') {
          let searchResult = [];
          _.forEach(this.marketData[marketDataIndex].marketData.userFiltersBackup.geography, (obj) => {
            if(searchRegex.test(obj.geographicTitle)) {
              searchResult.push(obj);
            }
          });
          if (searchResult.length > 0) {
            this.marketData[marketDataIndex].marketData.userFilters.geography = searchResult;
          }
          else {
            this.marketData[marketDataIndex].marketData.userFilters.geography.noSearchResults = true;
          }
        } else {
          this.marketData[marketDataIndex].marketData.userFilters.geography =
            this.marketData[marketDataIndex].marketData['userFiltersBackup'].geography;
        }
        this.marketData[marketDataIndex].marketData.userFilters.geography.searchString = text;
        break;
      case 'country':
        this.marketData[marketDataIndex].marketData.userFilters.country.noSearchResults = false;
        if (text !== '') {
          let searchResult = [];
          _.forEach(this.marketData[marketDataIndex].marketData.userFiltersBackup.country, (obj) => {
            if(searchRegex.test(obj.countryName)) {
              searchResult.push(obj);
            }
          });
          if (searchResult.length > 0) {
            this.marketData[marketDataIndex].marketData.userFilters.country = searchResult;
          }
          else {
            this.marketData[marketDataIndex].marketData.userFilters.country.noSearchResults = true;
          }
        } else {
          this.marketData[marketDataIndex].marketData.userFilters.country =
            this.marketData[marketDataIndex].marketData['userFiltersBackup'].country;
        }
        this.marketData[marketDataIndex].marketData.userFilters.country.searchString = text;
        break;
      case 'industry':
        this.marketData[marketDataIndex].marketData.userFilters.industry.noSearchResults = false;
        if (text !== '') {
          let searchResult = [];
          _.forEach(this.marketData[marketDataIndex].marketData.userFiltersBackup.industry, (obj) => {
            if(searchRegex.test(obj.industryName)) {
              searchResult.push(obj);
            }
          });
          if (searchResult.length > 0) {
            this.marketData[marketDataIndex].marketData.userFilters.industry = searchResult;
          }
          else {
            this.marketData[marketDataIndex].marketData.userFilters.industry.noSearchResults = true;
          }
        } else {
          this.marketData[marketDataIndex].marketData.userFilters.industry =
            this.marketData[marketDataIndex].marketData['userFiltersBackup'].industry;
        }
        this.marketData[marketDataIndex].marketData.userFilters.industry.searchString = text;
        break;
      case 'employeeSize':
        this.marketData[marketDataIndex].marketData.userFilters.employeeSize.noSearchResults = false;
        if (text !== '') {
          let searchResult = [];
          _.forEach(this.marketData[marketDataIndex].marketData.userFiltersBackup.employeeSize, (obj) => {
            if (obj.label) {
              if(searchRegex.test(obj.label)) {
                searchResult.push(obj);
              }
            }
            else {
              if((searchRegex.test(obj.employeeSizeFrom) )||(searchRegex.test(obj.employeeSizeTo)) ) {
                searchResult.push(obj);
              }    
            }
          });
          if (searchResult.length > 0) {
            this.marketData[marketDataIndex].marketData.userFilters.employeeSize = searchResult;
          }
          else {
            this.marketData[marketDataIndex].marketData.userFilters.employeeSize.noSearchResults = true;
          }
        } else {
          this.marketData[marketDataIndex].marketData.userFilters.employeeSize =
            this.marketData[marketDataIndex].marketData['userFiltersBackup'].employeeSize;
        }
        this.marketData[marketDataIndex].marketData.userFilters.employeeSize.searchString = text;
        break;
      case 'lineOfBusiness':
        this.marketData[marketDataIndex].marketData.userFilters.lineOfBusiness.noSearchResults = false;
        if (text !== '') {
          let searchResult = [];
          _.forEach(this.marketData[marketDataIndex].marketData.userFiltersBackup.lineOfBusiness, (obj) => {
            if(searchRegex.test(obj.lineOfBusiness)) {
              searchResult.push(obj);
            }
          });
          if (searchResult.length > 0) {
            this.marketData[marketDataIndex].marketData.userFilters.lineOfBusiness = searchResult;
          }
          else {
            this.marketData[marketDataIndex].marketData.userFilters.lineOfBusiness.noSearchResults = true;
          }
        } else {
          this.marketData[marketDataIndex].marketData.userFilters.lineOfBusiness =
            this.marketData[marketDataIndex].marketData['userFiltersBackup'].lineOfBusiness;
        }
        this.marketData[marketDataIndex].marketData.userFilters.lineOfBusiness.searchString = text;
        break;
      case 'jobTitle':
        this.marketData[marketDataIndex].marketData.userFilters.jobTitle.noSearchResults = false;
        if (text !== '') {
          let searchResult = [];
          _.forEach(this.marketData[marketDataIndex].marketData.userFiltersBackup.jobTitle, (obj) => {
            if(searchRegex.test(obj.jobTitleName)) {
              searchResult.push(obj);
            }
          });
          if (searchResult.length > 0) {
            this.marketData[marketDataIndex].marketData.userFilters.jobTitle = searchResult;
          }
          else {
            this.marketData[marketDataIndex].marketData.userFilters.jobTitle.noSearchResults = true;
          }
        } else {
          this.marketData[marketDataIndex].marketData.userFilters.jobTitle =
            this.marketData[marketDataIndex].marketData['userFiltersBackup'].jobTitle;
        }
        this.marketData[marketDataIndex].marketData.userFilters.jobTitle.searchString = text;
        break;
      case 'itBudget':
        this.marketData[marketDataIndex].marketData.userFilters.itBudget.noSearchResults = false;
        if (text !== '') {
          let searchResult = [];
          _.forEach(this.marketData[marketDataIndex].marketData.userFiltersBackup.itBudget, (obj) => {
            if (obj.label) {
              if(searchRegex.test(obj.label)) {
                searchResult.push(obj);
              }
            }
            else {
              if((searchRegex.test(obj.itBudgetFrom) )||(searchRegex.test(obj.itBudgetTo)) ) {
                searchResult.push(obj);
              }    
            }
          });
          if (searchResult.length > 0) {
            this.marketData[marketDataIndex].marketData.userFilters.itBudget = searchResult;
          }
          else {
            this.marketData[marketDataIndex].marketData.userFilters.itBudget.noSearchResults = true;
          }
        } else {
          this.marketData[marketDataIndex].marketData.userFilters.itBudget =
            this.marketData[marketDataIndex].marketData['userFiltersBackup'].itBudget;
        }
        this.marketData[marketDataIndex].marketData.userFilters.itBudget.searchString = text;
        break;
      case 'revenue':
        break;
        case 'customQuestionFilters':
          let searchResult = [];
          let objectName;
          this.marketData[marketDataIndex].marketData.customQuestionFilters[index].noSearchResults = false;
          if (this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup[index].customChoiceFilter.length > 0) {
            _.forEach(this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup[index].customChoiceFilter, (obj) => {
              if(searchRegex.test(obj.label)) {
                searchResult.push(obj);
              }
            });
            objectName = 'customChoiceFilter';
          } else {
            _.forEach(this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup[index].choiceId, (obj) => {
              if(searchRegex.test(obj.text)) {
                searchResult.push(obj);
              }
            });
            objectName = 'choiceId';
          }
          if (text !== '') {
            if (searchResult.length > 0) {
              this.marketData[marketDataIndex].marketData.customQuestionFilters[index][objectName] = searchResult;
            }
            else {
              this.marketData[marketDataIndex].marketData.customQuestionFilters[index].noSearchResults = true;
            }
          } else {
            this.marketData[marketDataIndex].marketData.customQuestionFilters[index][objectName] =
            this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup[index][objectName];
          }
          this.marketData[marketDataIndex].marketData.customQuestionFilters[index].searchString = text;
          break;
      default:
        break;
    }
  }
  updateBackupCheckedStatus(marketDataIndex, type, checkedStatus, cIndex, qIndex?) {
    // index is for some looping types like customQuestionFilters and customUserProfileFilters.
    let actionObj;
    switch (type) {
      case 'solutions':
        actionObj = this.marketData[marketDataIndex].marketData.userFilters.solutions[cIndex];
        cIndex = _.findIndex(this.marketData[marketDataIndex].marketData.userFiltersBackup.solutions, {id: actionObj.id});
        this.marketData[marketDataIndex].marketData.userFiltersBackup.solutions[cIndex].status = checkedStatus;
        break;
      // case 'customUserProfileFilters':
      //   actionObj = this.marketData[marketDataIndex].marketData.customUserProfileFilters[qIndex].profileData[cIndex];
      //   cIndex = _.findIndex(this.marketData[marketDataIndex].marketData.customUserProfileFiltersBackup[qIndex].profileData, actionObj);
      //   this.marketData[marketDataIndex].marketData.customUserProfileFiltersBackup[qIndex].profileData[cIndex].status = checkedStatus;
      //   break;
      case 'customUserProfileFilters':
        actionObj = this.marketData[marketDataIndex].marketData.customUserProfileFilters[qIndex].profileData[cIndex];
        cIndex = _.findIndex(this.marketData[marketDataIndex].marketData.customUserProfileFiltersBackup[qIndex].profileData, {id: actionObj.id});
        this.marketData[marketDataIndex].marketData.customUserProfileFiltersBackup[qIndex].profileData[cIndex].status = checkedStatus;
        break;
      case 'geography':
        actionObj = this.marketData[marketDataIndex].marketData.userFilters.geography[cIndex];
        cIndex = _.findIndex(this.marketData[marketDataIndex].marketData.userFiltersBackup.geography, {id: actionObj.id});
        this.marketData[marketDataIndex].marketData.userFiltersBackup.geography[cIndex].status = checkedStatus;
        break;
      case 'country':
        actionObj = this.marketData[marketDataIndex].marketData.userFilters.country[cIndex];
        cIndex = _.findIndex(this.marketData[marketDataIndex].marketData.userFiltersBackup.country, {id: actionObj.id});
        this.marketData[marketDataIndex].marketData.userFiltersBackup.country[cIndex].status = checkedStatus;
        break;
      case 'industry':
        actionObj = this.marketData[marketDataIndex].marketData.userFilters.industry[cIndex];
        cIndex = _.findIndex(this.marketData[marketDataIndex].marketData.userFiltersBackup.industry, {id: actionObj.id});
        this.marketData[marketDataIndex].marketData.userFiltersBackup.industry[cIndex].status = checkedStatus;
        break;
      case 'employeeSize':
        actionObj = this.marketData[marketDataIndex].marketData.userFilters.employeeSize[cIndex];
        cIndex = _.findIndex(this.marketData[marketDataIndex].marketData.userFiltersBackup.employeeSize, {id: actionObj.id});
        this.marketData[marketDataIndex].marketData.userFiltersBackup.employeeSize[cIndex].status = checkedStatus;
        break;
      case 'lineOfBusiness':
        actionObj = this.marketData[marketDataIndex].marketData.userFilters.lineOfBusiness[cIndex];
        cIndex = _.findIndex(this.marketData[marketDataIndex].marketData.userFiltersBackup.lineOfBusiness, {id: actionObj.id});
        this.marketData[marketDataIndex].marketData.userFiltersBackup.lineOfBusiness[cIndex].status = checkedStatus;
        break;
      case 'jobTitle':
        actionObj = this.marketData[marketDataIndex].marketData.userFilters.jobTitle[cIndex];
        cIndex = _.findIndex(this.marketData[marketDataIndex].marketData.userFiltersBackup.jobTitle, {id: actionObj.id});
        this.marketData[marketDataIndex].marketData.userFiltersBackup.jobTitle[cIndex].status = checkedStatus;
        break;
      case 'itBudget':
        actionObj = this.marketData[marketDataIndex].marketData.userFilters.itBudget[cIndex];
        cIndex = _.findIndex(this.marketData[marketDataIndex].marketData.userFiltersBackup.itBudget, {id: actionObj.id});
        this.marketData[marketDataIndex].marketData.userFiltersBackup.itBudget[cIndex].status = checkedStatus;
        break;
      case 'revenue':
        break;
      case 'customQuestionFilters':
        if (this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup[qIndex].customChoiceFilter.length > 0) {
          actionObj = this.marketData[marketDataIndex].marketData.customQuestionFilters[qIndex].customChoiceFilter[cIndex];
          cIndex = _.findIndex(this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup[qIndex].customChoiceFilter, {id: actionObj.id});
        
          // this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup[qIndex].customChoiceFilter[cIndex].status = checkedStatus;
          if (this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup[qIndex].isVendorQuestionFilter === true) {
            // as it is radio group, removing all other checked.
            _.forEach(this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup[qIndex].customChoiceFilter, (choiceObj) => {
              choiceObj.status = false;
            });
            this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup[qIndex].customChoiceFilter[cIndex].status = checkedStatus;
          }
          else {
            this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup[qIndex].customChoiceFilter[cIndex].status = checkedStatus;
          }
        } else {
          actionObj = this.marketData[marketDataIndex].marketData.customQuestionFilters[qIndex].choiceId[cIndex];
          cIndex = _.findIndex(this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup[qIndex].choiceId, {id: actionObj.id});
          if (this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup[qIndex].isVendorQuestionFilter === true) {
            // as it is radio group, removing all other checked.
            _.forEach(this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup[qIndex].choiceId, (choiceObj) => {
              choiceObj.status = false;
            });
            this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup[qIndex].choiceId[cIndex].status = checkedStatus;
          }
          else {
            this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup[qIndex].choiceId[cIndex].status = checkedStatus;
          }
        }
        break;
      default:
        break;
    }
  }
  backUpdata(marketDataIndex) {
    if (!this.marketData[marketDataIndex].marketData['userFiltersBackup']) {
      this.marketData[marketDataIndex].marketData['userFiltersBackup'] = _.cloneDeep(this.marketData[marketDataIndex].marketData.userFilters);
      if (this.marketData[marketDataIndex].marketData['userFiltersBackup'] == undefined) {
        this.marketData[marketDataIndex].marketData['userFiltersBackup'] = [];
      }
    }
    if (!this.marketData[marketDataIndex].marketData['customQuestionFiltersBackup']) {
      this.marketData[marketDataIndex].marketData['customQuestionFiltersBackup'] =
      _.cloneDeep(this.marketData[marketDataIndex].marketData.customQuestionFilters);
      if (this.marketData[marketDataIndex].marketData['customQuestionFiltersBackup'] === undefined) {
        this.marketData[marketDataIndex].marketData['customQuestionFiltersBackup'] = [];
      }
      this.marketData[marketDataIndex].marketData.customQuestionFiltersBackup.forEach((questionFilter: any) => {
        questionFilter.status = false;
        questionFilter.choiceId.forEach((choice: any) => {
          choice.status = false;
        });
        questionFilter.customChoiceFilter.forEach((choice: any) => {
          choice.status = false;
        });
      });
    }
    if (!this.marketData[marketDataIndex].marketData['customUserProfileFiltersBackup']) {
      this.marketData[marketDataIndex].marketData['customUserProfileFiltersBackup'] =
      _.cloneDeep(this.marketData[marketDataIndex].marketData.customUserProfileFilters);
      if (this.marketData[marketDataIndex].marketData['customUserProfileFiltersBackup'] == undefined) {
        this.marketData[marketDataIndex].marketData['customUserProfileFiltersBackup'] = [];
      }
      this.marketData[marketDataIndex].marketData.customUserProfileFiltersBackup.forEach((profileFilter: any) => {
        profileFilter.status = false;
        profileFilter.profileData.forEach((obj) => {
          obj.status = false;
        })
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/research-detail/research-detail.component.ts